define(["loglevel","jquery","backbone","underscore","toastr","fenix-ui-menu","fenix-ui-catalog","fenix-ui-bridge","q","fenix-ui-filter","fenix-ui-metadata-editor","fenix-ui-DSDEditor","fenix-ui-DataEditor"], function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_34__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_46__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_50__, __WEBPACK_EXTERNAL_MODULE_53__, __WEBPACK_EXTERNAL_MODULE_56__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define, require*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(6),
	    __webpack_require__(4),
	    __webpack_require__(64),
	    __webpack_require__(37),
	    __webpack_require__(31),
	    __webpack_require__(2),
	    __webpack_require__(65),
	    __webpack_require__(66),
	    __webpack_require__(67)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (log, $, Router, Template, C, ERR, CatalogConfig, DsdEditorConfig, DataEditorConfig, MetadataEditorConfig) {
	
	    "use strict";
	
	    function DataManagement(o) {
	        log.info("FENIX Data Management", o);
	
	        $.extend(true, this, {initial: o});
	
	        __webpack_require__(68);
	
	        this._parseInput();
	
	        var valid = this._validateInput();
	
	        if (valid === true) {
	
	            this._attach();
	
	            this._start();
	
	        } else {
	            log.error("Impossible to create Data Management");
	            log.error(valid)
	        }
	    }
	
	    DataManagement.prototype._validateInput = function () {
	
	        var valid = true,
	            errors = [];
	
	        //Check if $el exist
	        if (this.$el.length === 0) {
	            errors.push({code: ERR.MISSING_CONTAINER});
	            log.warn("Impossible to find container");
	        }
	
	        return errors.length > 0 ? errors : valid;
	    };
	
	    DataManagement.prototype._attach = function () {
	        this.$el.html(Template);
	
	        log.info("Template attach : success");
	    };
	
	    DataManagement.prototype._parseInput = function () {
	
	        this.$el = $(this.initial.el);
	        this.cache = typeof this.initial.cache === "boolean" ? this.initial.cache : C.cache;
	        this.environment = this.initial.environment;
	        this.lang = this.initial.lang || C.lang;
	
	        this.routes = this.initial.routes;
	        this.disabledSections = this.initial.disabledSections || [];
	
	        this.menuConfig = this.initial.menuConfig;
	
	        this.catalogConfig = this.initial.catalog || CatalogConfig;
	        this.dsdEditorConfig = this.initial.dsdEditor || DsdEditorConfig;
	        this.dataEditorConfig = this.initial.dataEditor || DataEditorConfig;
	        this.metadataEditorConfig = this.initial.metadataEditor || MetadataEditorConfig;
	        this.metadataConverters = this.initial.metadataConverters;
	        this.config = this.initial.config || C.config;
	
	        this.resourceManager = this.initial.resourceManager || "default";
	
	        this.notifyConfig = this.initial.notifyConfig;
	
	        this.metadataEnvironment = this.initial.metadataEnvironment || this.environment;
	        this.catalogEnvironment = this.initial.catalogEnvironment || this.environment;
	        this.dmEnvironment = this.initial.dmEnvironment || this.environment;
	
	        this.extraBridge = this.initial.extraBridge || false;
	
	        this.serviceProvider = this.initial.serviceProvider || undefined ;
	
	    };
	
	    DataManagement.prototype._start = function () {
	
	        var model = {
	            $el: this.$el,
	            cache: this.cache,
	            environment: this.environment,
	            lang: this.lang,
	            config: this.config,
	            menuConfig: this.menuConfig,
	            catalogConfig: this.catalogConfig,
	            metadataEditorConfig: this.metadataEditorConfig,
	            metadataConverters: this.metadataConverters,
	            dsdEditorConfig: this.dsdEditorConfig,
	            dataEditorConfig: this.dataEditorConfig,
	            routes: this.routes,
	            disabledSections: this.disabledSections,
	            notifyConfig: this.notifyConfig,
	            metadataEnvironment : this.metadataEnvironment,
	            catalogEnvironment : this.catalogEnvironment,
	            dmEnvironment : this.dmEnvironment,
	            extraBridge : this.extraBridge,
	            resourceManager : this.resourceManager,
	            serviceProvider : this.serviceProvider
	        };
	
	        //console.log(model);
	
	        log.info("Router config:");
	        log.info(model);
	
	        this.router = new Router(model);
	
	        log.info("Router start: success");
	    };
	
	    return DataManagement;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	        defaultSelectors: ['freeText', 'resourceType', 'contextSystem'],
	
	        hideCloseButton: true,
	
	        pluginRegistry: {
	            contextSystem: {
	                selector: {
	                    id: "dropdown",
	                    source: [
	                        {value: "fenix_develop", label: "FENIX develop"},
	                        {value: "gift", label: "GIFT"},
	                        {value: "cstat_training", label: "CountrySTAT Training"}
	                    ],
	                    default: ["fenix_develop"],
	                    hideSummary: true,
	                    config: {
	                        plugins: ['remove_button'],
	                        mode: 'multi'
	                    }
	                },
	
	                template: {
	                    hideRemoveButton: false
	                },
	
	                format: {
	                    output: "enumeration",
	                    metadataAttribute: "dsd.contextSystem"
	                }
	            }
	        }
	
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define, _:false*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(33),
	    __webpack_require__(3),
	    __webpack_require__(34),
	    __webpack_require__(35),
	    __webpack_require__(36),
	    __webpack_require__(37),
	    __webpack_require__(32),
	    __webpack_require__(38),
	    __webpack_require__(39),
	    __webpack_require__(5),
	    __webpack_require__(40),
	    __webpack_require__(44),
	    __webpack_require__(45),
	    __webpack_require__(48),
	    __webpack_require__(52),
	    __webpack_require__(55),
	    __webpack_require__(60),
	    __webpack_require__(62),
	    __webpack_require__(63),
	    __webpack_require__(8)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, _, log, Notify, NotifyConfig, Routes, C, EVT, Menu, ConfigMenu,
	             LandingView, SearchView, NotFoundView, DeleteView, MetadataView, DSDView, DataView, HomeView,
	             RM, RMGift,
	             labels) {
	
	    'use strict';
	
	    var s = {
	            MENU: '#fx-data-management-menu',
	            CONTAINER: '#fx-data-management-content',
	            HOLDER: "#fx-data-management-content-holder",
	            BTN_CONTAINER: "#fx-data-managment-update-model-holder",
	            BTN_ELEMENT: "#fx-data-managment-update-button",
	            HEADER: "#fx-data-managment-header-title",
	            RES_TITLE: "#fx-data-managment-resource-title"
	        },
	        r = Routes;
	
	    return Backbone.Router.extend({
	
	        // The Router constructor
	        initialize: function (o) {
	            log.info("Router params:");
	            log.info(o);
	
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            this._initVariables();
	
	            this._initComponents();
	
	            this._bindEventListeners();
	
	            Backbone.history.start();
	            log.info("Backbone.history.start() success");
	        },
	
	        routes: r,
	
	        _parseInput: function () {
	
	            this.$el = this.initial.$el;
	            this.container = this.initial.container || s.CONTAINER;
	            this.cache = this.initial.cache;
	            this.environment = this.initial.environment;
	            this.lang = this.initial.lang;
	            this.lang = this.lang.toLowerCase();
	
	            this.notifyConfig = this.initial.notifyConfig || NotifyConfig;
	
	            this.config = this.initial.config;
	
	            this.dsdEditorConfig = this.initial.dsdEditorConfig || {};
	            this.catalogConfig = this.initial.catalogConfig || {};
	            this.metadataEditorConfig = this.initial.metadataEditorConfig || {};
	            this.dataEditorConfig = this.initial.dataEditorConfig || {};
	            this.menuConfig = this.initial.menuConfig || ConfigMenu;
	
	            this.metadataConverters = this.initial.metadataConverters;
	
	            this.disabledSections = this.initial.disabledSections || [];
	
	            this.metadataEnvironment = this.initial.metadataEnvironment || this.environment;
	            this.catalogEnvironment = this.initial.catalogEnvironment || this.environment;
	            this.dmEnvironment = this.initial.dmEnvironment || this.environment;
	
	            this.extraBridge = this.initial.extraBridge || false;
	
	            this.resourceManager = this.initial.resourceManager || "default";
	
	            (this.resourceManager == "default") ? this.RM = RM : this.RM = RMGift;
	
	            this.serviceProvider = this.initial.serviceProvider || undefined ;
	
	            //console.log(this.RM);
	
	            //console.log("SERV", this.serviceProvider);
	
	            r = this.initial.routes || r;
	
	        },
	
	        _initVariables: function () {
	
	            this.$viewsHolder = this.$el.find(s.HOLDER);
	            this.$header = this.$el.find(s.HEADER);
	            this.$pageTitle = this.$el.find(s.RES_TITLE);
	        },
	
	        _initComponents: function () {
	            log.info("Render common views");
	
	            Notify.options = this.notifyConfig.errors;
	
	            this.RM.init({
	                environment: this.dmEnvironment,
	                cache: this.cache,
	                extra: this.extraBridge,
	                serviceProvider : this.serviceProvider
	            });
	
	            this._initMenu();
	
	            log.info("Router components init: success");
	        },
	
	        _initMenu: function () {
	            log.info("render menu");
	
	            this.menu = new Menu({
	                lang: this.lang,
	                config: this.menuConfig,
	                container: s.MENU
	            });
	
	            this._activateInitialMenuItems();
	        },
	
	        _activateInitialMenuItems: function () {
	            this.menu.disable(C.menuItems);
	            this.menu.activate(C.menuItemsEnabledOnStart);
	
	            log.info("Activate menu initial items: success");
	        },
	
	        _activateValidResourceMenuItems: function () {
	
	            this.menu.disable(C.menuItems);
	            this.menu.activate(C.menuItemsEnableOnValidResource);
	
	            log.info("Activate valid resource menu items: success");
	
	        },
	
	        _bindEventListeners: function () {
	
	            var self = this;
	
	            this.menu.on("select", function (evt) {
	                log.info("Listen to menu event: " + evt.id);
	                self.goTo("#/" + evt.id);
	            });
	
	            // RESOURCES
	
	            // When a resource is created (new button)
	            this.listenTo(Backbone, EVT.RESOURCE_CREATED, function () {
	                log.info("[EVT] resource:new");
	                Notify['info'](labels[self.lang]['resourceNew'], "" ,this.notifyConfig.info);
	                self._activateValidResourceMenuItems();
	                self.goTo("#/metadata");
	            });
	
	            // When a resource is deleted (confirm is deletion)
	            this.listenTo(Backbone, EVT.RESOURCE_DELETED, function () {
	                log.info("[EVT] resource:deleted ", this.RM.resource);
	                Notify['success'](labels[self.lang]['resourceDeleted'], "" ,this.notifyConfig.info);
	                self._activateInitialMenuItems();
	                self.goTo("#/landing");
	            });
	
	            this.listenTo(Backbone, EVT.RESOURCE_LOAD, function (res) {
	                log.info("[EVT] resource:loading ", res);
	
	                if (this.waiting === true) {
	                    log.warn("Abort loading resource because another one is already loading");
	                    Notify['info'](labels[self.lang]['alreadyLoading'], "" ,this.notifyConfig.info);
	                    return;
	                }
	
	                this.waiting = true;
	
	                this.RM.unloadResource();
	                this.RM.loadResource(res);
	            });
	
	            // When a resource is in tentative deletion (still there)
	            this.listenTo(Backbone, EVT.RESOURCE_DELETE, function () {
	                log.info("[EVT] resource:delete");
	                this.RM.deleteResource();
	            });
	
	            // When a resource is loaded (fully)
	            this.listenTo(Backbone, EVT.RESOURCE_LOADED, function () {
	                log.info("[EVT] resource:loaded ");
	                this.waiting = false;
	                self._activateValidResourceMenuItems();
	                Notify['success'](labels[self.lang]['resourceLoaded'], "" ,this.notifyConfig.info);
	                self.goTo("#/home");
	            });
	
	            // When a resource is unloaded (search or new is triggered)
	            this.listenTo(Backbone, EVT.RESOURCE_UNLOADED, function () {
	                log.info("[EVT] resource:unloaded ", this.RM.resource);
	                self._activateInitialMenuItems();
	            });
	
	            // When the save button is clicked
	            this.listenTo(Backbone, EVT.RESOURCE_UPDATED, function () {
	                log.info("[EVT] resource:updated ", this.RM.resource);
	                Notify['success'](labels[self.lang]['resourceSaved'], "" ,this.notifyConfig.info);
	                self.goTo("#/home");
	            });
	
	            // RESOURCES End
	
	            this.listenTo(Backbone, "data:loading", function () {
	                log.info("[EVT] data:loading ");
	                //TODO: Do some stuff here;
	            });
	
	            this.listenTo(Backbone, "data:loaded", function () {
	                log.info("[EVT] data:loaded ");
	                Notify['success'](labels[self.lang]['csvLoaded'], "" ,this.notifyConfig.info);
	            });
	
	            this.listenTo(Backbone, "data:saving", function (res) {
	                log.info("[EVT] data:saving");
	                this.RM.setData(res);
	            });
	
	            // METADATA
	
	            this.listenTo(Backbone, EVT.METADATA_CREATE, function (res) {
	                log.info("[EVT] meta:creating");
	                this.RM.updateMetadata(res);
	                this.RM.createResource(this.config);
	            });
	
	
	            this.listenTo(Backbone, EVT.METADATA_SAVE, function (res) {
	                log.info("[EVT] meta:saving");
	                this.RM.updateMetadata(res);
	                this.RM.saveMetadata();
	            });
	
	            this.listenTo(Backbone, EVT.METADATA_COPY_EMPTY_RESOURCE, function () {
	                Notify['warning'](labels[this.lang][EVT.METADATA_COPY_EMPTY_RESOURCE], "" ,this.notifyConfig.info);
	            });
	
	            this.listenTo(Backbone, EVT.METADATA_COPY_SUCCESS, function () {
	                Notify['success'](labels[this.lang][EVT.METADATA_COPY_SUCCESS], "" ,this.notifyConfig.info);
	            });
	
	            // When a metadata is in tentative deletion (still there)
	            this.listenTo(Backbone, EVT.METADATA_DELETE, function () {
	                log.info("[EVT] METADATA_DELETE ");
	                this.RM.deleteMetadata();
	            });
	
	            //DSD
	
	            this.listenTo(Backbone, EVT.DSD_SAVE, function (dsd) {
	                log.info("[EVT] dsd:saving");
	                this.RM.updateDsd(dsd);
	                this.RM.saveDsd();
	            });
	
	            this.listenTo(Backbone, EVT.DSD_COPY_EMPTY_RESOURCE, function (dsd) {
	                Notify['warning'](labels[this.lang][EVT.DSD_COPY_EMPTY_RESOURCE], "" ,this.notifyConfig.info);
	            });
	
	            this.listenTo(Backbone, EVT.DSD_COPY_SUCCESS, function (dsd) {
	                Notify['success'](labels[this.lang][EVT.DSD_COPY_SUCCESS], "" ,this.notifyConfig.info);
	            });
	
	            // ERRORS
	
	            this.listenTo(Backbone, "error:showerrormsg", function (message) {
	                log.info("[EVT] error:showerrormsg >>", message);
	                Notify['error'](message);
	
	                self.waiting = false;
	            });
	
	            this.listenTo(Backbone, "error:showerror", function (code, xhr) {
	                log.info("[EVT] error:showerror ", code, xhr);
	                var out = labels[this.lang][code] || JSON.stringify(xhr) || "Generic Error";
	                Notify['error'](out);
	            });
	
	            this.listenTo(Backbone, "error:showerrorsrv", function (code, xhr) {
	                log.info("[EVT] error:showerrorsrv ", code, xhr);
	                var out = labels[this.lang][code] || "Server: " + JSON.stringify((xhr.responseJSON != undefined)? xhr.statusText : xhr.responseJSON) || "Generic Error";
	                Notify['error'](out);
	            });
	
	            this.listenTo(Backbone, EVT.METADATA_INFO, function (code, xhr) {
	                log.info("[EVT] error:showerrorsrv ", code, xhr);
	                var out = labels[this.lang][code] || "Server: " + JSON.stringify((xhr.responseJSON != undefined)? xhr.statusText : xhr.responseJSON) || "Generic Error";
	                Notify['info'](out);
	            });
	
	            this.listenTo(Backbone, EVT.DSD_INFO, function (code, xhr) {
	                log.info("EVT.DSD_INFO", code, xhr);
	                var out = labels[this.lang][code];
	                //console.log(' EVT.DSD_INFO', out );
	                //Notify['info'](out);
	            });
	
	            // BUTTONS
	
	            this.listenTo(Backbone, EVT.SHOW_ADD, function () {
	                log.info("[EVT] button:new ");
	                this.goTo("#/add");
	            });
	
	            this.listenTo(Backbone, EVT.SHOW_SEARCH, function () {
	                log.info("[EVT] button:search ");
	                this.goTo("#/search");
	            });
	
	            this.listenTo(Backbone, EVT.RESOURCE_DELETE_UNDO, function () {
	                log.info("[EVT] button:undo ");
	                this.goTo("#/home");
	            });
	
	            this.listenTo(Backbone, EVT.SHOW_METADATA, function () {
	                log.info("[EVT] button:metadata ");
	                this.goTo("#/metadata");
	            });
	
	            this.listenTo(Backbone, EVT.SHOW_DSD, function () {
	                log.info("[EVT] button:dsd ");
	                this.goTo("#/dsd");
	            });
	
	            this.listenTo(Backbone, EVT.SHOW_DATA, function () {
	                log.info("[EVT] button:data ");
	                this.goTo("#/data");
	            });
	
	            log.info("Router events binding: success");
	        },
	
	        //  ================================= ROUTING
	
	        //Landing
	
	        onLanding: function () {
	            log.info("onLanding called.");
	
	            this.switchView(LandingView, {
	                el: this.container,
	                menu: "landing",
	                lang: this.lang
	            });
	        },
	
	        //Home
	
	        onHome: function () {
	            log.info("onHome called.");
	
	            this.switchView(HomeView, {
	                el: this.container,
	                menu: "home",
	                lang: this.lang,
	                disabledSections: this.disabledSections,
	                environment: this.environment,
	                serviceProvider : this.serviceProvider
	            });
	        },
	
	        //Search
	
	        onSearch: function () {
	            log.info("onSearch called.");
	
	            this.switchView(SearchView, {
	                el: this.container,
	                menu: "search",
	                lang: this.lang,
	                cache: this.cache,
	                environment: this.catalogEnvironment,
	                catalog: this.catalogConfig
	            });
	        },
	
	        //Denied
	
	        onDenied: function () {
	            log.info("Denied - Routing to Lading");
	
	            this.goTo("#/landing");
	        },
	
	        onClose: function () {
	            log.info("Close - Routing to Landing");
	
	            if (!$.isEmptyObject(this.RM.resource)) {
	                this.RM.unloadResource();
	                Notify['success'](labels[this.lang]['CloseHeader'], "" ,this.notifyConfig.info);
	            }
	
	            this.goTo("#/landing");
	        },
	
	        // Add Resource
	
	        onAdd: function () {
	            log.info("Add Resource");
	
	            this.RM.unloadResource();
	            this.RM.createResource(this.config)
	
	        },
	
	        // Metadata View
	
	        onMetadata: function () {
	            log.info("Metadata View");
	
	            //console.log('metadata!', RM.getMetadata());
	
	            // Init Buttons
	            this.switchView(MetadataView, {
	                el: this.container,
	                menu: "metadata",
	                copy: this.config.copyMeta,
	                lang: this.lang,
	                environment: this.metadataEnvironment,
	                serviceProvider : this.serviceProvider,
	                config: this.metadataEditorConfig,
	                model: this.RM.getMetadata(),
	                converters: this.metadataConverters,
	                label: this.config.labelMeta,
	            });
	        },
	
	        // DSD View
	
	        onDSD: function () {
	
	            log.info("DSD View");
	            // Check if MD is Enabled
	
	            if (this.RM.MetadataExist()) {
	
	                // Init Buttons
	                this.switchView(DSDView, {
	                    el: this.container,
	                    menu: "dsd",
	                    lang: this.lang,
	                    environment: this.environment,
	                    serviceProvider : this.serviceProvider,
	                    config: $.extend(true, this.dsdEditorConfig, {
	                        lang : this.lang,
	                        contextSystem: this.config.contextSystem,
	                        datasources: this.config.datasources
	                    }),
	                    model: this.RM.getDSD(),
	                    isEditable: this.RM.isDSDEditable()
	                });
	            } else {
	                Notify['error'](labels[this.lang]['errorMDisEmpty']);
	                this.goTo("#/home");
	            }
	        },
	
	        // Data View
	
	        onData: function () {
	            log.info("Data View");
	            // Check if DSD is Enabled
	            if(this.RM.DSDExist()) {
	                this.switchView(DataView, {
	                    el: this.container,
	                    menu: "data",
	                    config: this.dataEditorConfig,
	                    lang: this.lang,
	                    codelists: this.RM.getCurrentResourceCodelists(),
	                    dsd: this.RM.getDSD(),
	                    data: this.RM.getData(),
	                    generator: this.RM.generateDSDStructure(),
	                    environment: this.environment,
	                    serviceProvider : this.serviceProvider
	                });
	            } else {
	                Notify['error'](labels[this.lang]['errorDSDisEmpty']);
	                this.goTo("#/home");
	            }
	        },
	
	        // Delete Resource
	
	        onDelete: function () {
	            log.info("Delete Resource");
	            this.switchView(DeleteView, {
	                el: this.container,
	                menu: "delete",
	                lang: this.lang,
	                environment: this.environment,
	                serviceProvider : this.serviceProvider,
	            });
	        },
	
	        onDeleteMetadata: function () {
	            log.info("Delete Metadata");
	            this.switchView(DeleteView, {
	                el: this.container,
	                menu: "delete",
	                lang: this.lang,
	                environment: this.metadataEnvironment,
	                deleteMetadata: true
	            });
	        },
	
	        //Not found
	
	        onNotFound: function () {
	
	            log.info("Not found");
	
	            this.switchView(NotFoundView, {
	                el: this.container,
	                lang: this.lang
	            });
	        },
	
	        onDefaultRoute: function () {
	            log.info("Default");
	
	            this.goTo("#/not-found");
	        },
	
	        //Utils
	
	        switchView: function (View, o) {
	
	            if (this.currentViewCreator === View) {
	                log.warn("Abort switch view because candidate view is current view");
	                return;
	            }
	            this.currentViewCreator = View;
	
	            log.info("Switch view");
	
	            var self = this,
	                candidate = new View(o);
	
	            if (typeof candidate.accessControl === "function") {
	                log.info("View has access control", this.RM.resource);
	                candidate.accessControl(this.RM.resource).then(
	                    function () {
	                        log.warn("Access control: GRANTED");
	                        self.resetView();
	                        self.renderView(View, o);
	
	                    },
	                    function () {
	                        log.warn("Access control: DENIED");
	                        self.resetView();
	                        self.onDenied()
	                    }
	                );
	            } else {
	                log.info("View has NOT access control");
	                this.resetView();
	                this.renderView(View, o)
	            }
	            this._updatePageTitle();
	
	        },
	
	        resetView: function () {
	            this.disposeCurrentView();
	            this.addViewContainer();
	        },
	
	        renderView: function (View, o) {
	
	            this.menu.select(o.menu);
	
	            this.currentView = new View(o).render(o);
	
	        },
	
	        _updatePageTitle: function () {
	
	            var stringTitle = "",
	                self = this,
	                head = "";
	
	            $.each(this.menu.o.conf.items, function(index,object){
	                if (object.attrs.id == self.menu.o.active) head = object.label[self.lang.toUpperCase()];
	            });
	
	            this.$header.html(head);
	
	            if ($.isPlainObject(this.RM.resource.metadata)) {
	                if (this.RM.resource.metadata.title) {
	                    log.info(this.RM.resource.metadata.title);
	                    stringTitle = ' / ' + (this.RM.resource.metadata.title[this.lang.toUpperCase()] || this.RM.resource.metadata.title['EN']);
	                } else {
	                    stringTitle = ' / ' + labels[this.lang.toLowerCase()]['NoTitle'];
	                }
	            }
	
	            this.$pageTitle.html(stringTitle);
	
	        },
	
	        disposeCurrentView: function () {
	
	            if (this.currentView && this.currentView.remove) {
	
	                this.currentView.remove();
	
	                delete this.currentView;
	
	                log.info("Removed current view");
	            }
	
	            log.info("Dispose current view: success");
	        },
	
	        addViewContainer: function () {
	            this.$viewsHolder.html('<div id="' + s.CONTAINER.substring(1) + '"></div>');
	            log.info("Add view container: success");
	        },
	
	        goTo: function (loc, trigger, replace) {
	            this.navigate(loc, {trigger: !!trigger, replace: !!replace});
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3),
	    __webpack_require__(8),
	    __webpack_require__(11),
	    __webpack_require__(31),
	    __webpack_require__(32),
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log, labels, Template, ERR, EVT) {
	    "use strict";
	    var s = {
	        btnSearch: "#btnSearch",
	        btnAdd: "#btnAdd",
	        DManHeader: "#DManHeader",
	        DManIntro: "#DManIntro"
	    };
	
	    var LandingView = Backbone.View.extend({
	
	        render: function (o) {
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	                log.info("Rendering View - Landing", this);
	                this._attach();
	                this._bindEventListeners();
	                return this;
	            } else {
	                log.error("Impossible to render Landing");
	                log.error(valid)
	            }
	        },
	
	        _attach: function () {
	            this.$el.html(Template({
	                dManHeader: labels[this.lang]['DManHeader'],
	                dManIntro: labels[this.lang]['DManIntro'],
	                searchBtn: labels[this.lang]['btnSearch'],
	                addBtn: labels[this.lang]['btnAdd']
	            }));
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            //Check if $el exist
	            if (this.$el.length === 0) {
	                errors.push({code: ERR.MISSING_CONTAINER});
	                log.warn("Impossible to find container");
	            }
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	
	            this.cache = this.initial.cache;
	
	            this.environment = this.initial.environment;
	
	            this.lang = this.initial.lang.toLowerCase();
	        },
	
	        _bindEventListeners: function () {
	
	            this.$el.find(s.btnSearch).on("click", function () {
	                Backbone.trigger(EVT.SHOW_SEARCH);
	            });
	
	            this.$el.find(s.btnAdd).on("click", function () {
	                Backbone.trigger(EVT.SHOW_ADD);
	            });
	        },
	
	        _unbindEventListeners: function () {
	
	            this.$el.find(s.btnSearch).off();
	
	            this.$el.find(s.btnAdd).off();
	        },
	
	        remove: function () {
	
	            this._unbindEventListeners();
	
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return LandingView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(9),
	        __webpack_require__(10)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function (i18nEn, i18nFr) {
	
	        'use strict';
	
	        return {
	
	            en: i18nEn,
	            fr: i18nFr
	
	        }
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	    return {
	        //Generic
	        "confirmDataRemove": "Do you want to delete all your data?",
	        "success": "Success",
	        "resourceNew":"Resource created",
	        "resourceSaved":"Resource saved",
	        "resourceDeleted": "Resource deleted",
	        "resourceLoaded": "Resource loaded",
	        "resourceCopied": "Resource copied",
	
	        "alreadyLoading" : "Please be patient. Resource is loading...",
	
	        // Errors
	        "error": "Error",
	        "errorMetaMinimum" : "Please fill the minimum set of metadata in the \"Identification\" and \"Contacts\" sections",
	        "errorParsingJson": "Error parsing JSON file, check the structure and try again",
	        "errorDSDisEmpty" : "DSD has no columns. Please fill DSD before using the Data Editor",
	        "errorMDisEmpty" : "Metadata is empty. Please fill Metadata before using the DSD Editor",
	
	        "errorLoadinResource": "Error loading the resource",
	        "errorSavingResource": "Error saving the resource",
	
	        "overwriteExistingDSD": "This operation will overwrite the DSD you're working on, continue?",
	        "unsavedWarning": "Some changes are not saved, do you want to continue without saving?",
	
	        "downloadDSD": "Download DSD",
	        "uploadDSD": "Upload DSD",
	
	        //Data Editor
	        "invalidData": "Data is not valid",
	        "nullDSDCols": "DSD has no columns",
	        "nullCsvCols": "CSV has no columns",
	        "wrongColumnCount": "The columns' count in the CSV must match the one in the DSD",
	        "wrongColumnId": "The columns' names in the CSV must match the IDs in the DSD",
	        "unknownCodes": "Some codes could not be found in a codelist",
	        "DataMatchColumn": "Match the DSD columns with the CSV ones",
	        "DataDuplicateFound" : "Some duplicated values found, keep old data or replace with the new values just uploaded?",
	        "btnDataMergeKeepNew" : "Replace with new values",
	        "btnDataMergeKeepOld" : "Keep old values",
	        "btnDataMergeCancel" : "Cancel",
	        "DataEditorMainContainer" : "LOADING...",
	        "DataDeleteAll":"Delete all",
	        "DatalblUpload":"Upload the CSV",
	        "DatalblSeparator":"CSV Separator",
	        "DatalblcsvSeparatorSemi" : "Semicolon",
	        "DatalblcsvSeparatorComma" : "Comma",
	        "csvLoaded": "CSV file Loaded",
	
	
	        //DataValidator
	        "unknownCode": "Unknown code",
	        "invalidYear": "Invalid year",
	        "invalidMonth": "Invalid month",
	        "invalidDate": "Invalid date",
	        "invalidNumber": "Invalid number",
	        "invalidBool": "Invalid boolean",
	
	        //Buttons
	        "btnSearch" : "SEARCH",
	        "btnAdd" : "ADD",
	        "btnMetadata" : "METADATA",
	        "btnDSD" : "DSD",
	        "btnData" : "DATA",
	        "btnSaveMeta" : "Save",
	        "btnCopyMeta" : "Copy Metadata",
	        "btnLoadMeta" : "Load",
	        "btnSaveDSD" : "Save",
	        "btnClose" : "Close",
	        "btnCsvMatcherOk" : "OK",
	        "btnCsvMatcherCancel" : "Cancel",
	        "btnHome" : "Home",
	        "btnDeleteUndo" : "Undo",
	        "btnDeleteConfirm" : "Confirm",
	        "dataEditEnd" : "Save",
	        //2.0
	        "btnSave" : "Save",
	        "btnUpdateResource" : "Update Resource",
	
	
	
	        //Headers
	        "DManHeader": "FENIX Data Management",
	        "DManResHeader" : "Edit Resource",
	        "MetaHeader" : "Metadata Editor",
	        "MetaCopyHeader" : "Copy metadata from",
	        "MetaCopyAlt" : "Copy metadata",
	        "DSDHeader" : "Data Structure Definition Editor",
	        "DataHeader" : "Data Editor",
	        "CloseHeader" : "Resource Closed",
	        "DeleteHeader" : "Delete Resource?",
	
	        //Titles
	
	
	        //Descriptions
	        "DManIntro" : "Data management is the process of controlling the information generated during a research project. Any research will require some level of data management, and funding agencies are increasingly requiring scholars to plan and execute good data management practices.",
	        "CopyMetaRID" : "Resource Identification Code",
	        "CopyMetaVer" : "Resource Version (if applicable)",
	        "NoTitle": "Untitled",
	        "CopyDSD" : "Copy DSD from:",
	        "CopyDSDAlt" : "Copy DSD",
	
	        //metadata validation
	        metadataValidationWarning : "Please fill the mandatory fields",
	
	        //DSD
	        DSD_COPY_SUCCESS : "DSD copied successfully",
	        DSD_COPY_EMPTY_RESOURCE : "Resource does not contains columns",
	        DSD_MINIMUM: "At least one column is required to save DSD",
	
	        //Metadata
	        METADATA_COPY_EMPTY_RESOURCE : "Resource not found",
	        METADATA_COPY_SUCCESS : "Metadata copied successfully",
	
	        //DATA
	        CSVSEPARATOR : "Please select a CSV separator"
	
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	    return {
	        //Generic
	        "confirmDataRemove": "Voulez-vous supprimer toutes les données?",
	        "success": "Succès",
	        "resourceNew": "Ressource créée",
	        "resourceSaved": "Ressource enregistrée",
	        "resourceDeleted": "Ressource supprimée",
	        "resourceLoaded": "Ressource chargée",
	        "resourceCopied": "Ressource copiée",
			
			"alreadyLoading" : "Veuillez patienter pendant le téléchargement de la ressource...",
	
	        // Errors
	        "error": "Erreur",
	        "errorMetaMinimum": "Veuillez remplir l'ensemble minimale de métadonnées dans les sections \"Identification\" et \"Contacts\"",
	        "errorParsingJson": "Erreur d'analyse du fichier Json, veuillez vérifier la structure et essayer de nouveau",
	        "errorDSDisEmpty" : "DSD n'a pas de colonnes. Veuillez remplir DSD avant d'utiliser l'éditeur de données",
	        "errorMDisEmpty" : "Les métadonnées sont vides. Remplissez métadonnées avant d'utiliser l'éditeur DSD",
	
	        "errorLoadinResource": "Erreur de chargement de la ressource",
	        "errorSavingResource": "Erreur d'enregistrement de la ressource",
	
	        "overwriteExistingDSD": "Cette opération écrasera le DSD sur lequel vous êtes en train de travailler, voulez-vous continuer?",
	        "unsavedWarning": "Certaines modifications n'ont pas été enregistrées, voulez-vous continuer sans enregistrer?",
	
	        "downloadDSD": "Téléchargez le DSD",
	        "uploadDSD": "Uploadez le DSD",
	
	        //Data Editor
	        "invalidData": "Les données ne sont pas valables",
	        "nullDSDCols": "Le DSD n'a pas de colonnes",
	        "nullCsvCols": "Le CSV n'a pas de colonnes",
	        "wrongColumnCount": "Le décompte des colonnes dans le CSV doit correspondre à celui du DSD",
	        "wrongColumnId": "Les noms des colonnes dans le CSV doivent correspondre aux IDs dans le DSD",
	        "unknownCodes": "Des codes n'ont pas été trouvés dans la codeliste",
	        "DataMatchColumn": "Veuillez faire correspondre les colonnes du DSD avec celles du CSV",
	        "DataDuplicateFound": "Des valeurs dupliquées ont été trouvées, voulez-vous conserver les valeurs anciennes ou les remplacer par les nouvelles?",
	        "btnDataMergeKeepNew": "Remplacer par les valeurs nouvelles",
	        "btnDataMergeKeepOld": "Conserver les valeurs anciennes",
	        "btnDataMergeCancel": "Annuler",
	        "DataEditorMainContainer": "Chargement en cours...",
	        "DataDeleteAll": "Supprimer tous",
	        "DatalblUpload": "Télécharger le CSV",
	        "DatalblSeparator": "Séparateur du CSV",
	        "DatalblcsvSeparatorSemi": "Point-virgule",
	        "DatalblcsvSeparatorComma": "Virgule",
	        "csvLoaded": "Ficher CSV chargé",
	
	
	        //DataValidator
	        "unknownCode": "Code inconnu",
	        "invalidYear": "Année invalide",
	        "invalidMonth": "Mois invalide",
	        "invalidDate": "Date invalide",
	        "invalidNumber": "Nombre invalide",
	        "invalidBool": "Valeur booléenne invalide",
	
	        //Buttons
	        "btnSearch": "RECHERCHER",
	        "btnAdd": "AJOUTER",
	        "btnMetadata": "MÉTADONNÉES",
	        "btnDSD": "DSD",
	        "btnData": "DONNÉES",
	        "btnSaveMeta": "Enregistrer",
	        "btnCopyMeta": "Copier les métadonnées",
	        "btnLoadMeta": "Charger",
	        "btnSaveDSD": "Enregistrer",
	        "btnClose" : "Fermer",
	        "btnCsvMatcherOk": "OK",
	        "btnCsvMatcherCancel": "Annuler",
	        "btnHome": "Accueil",
	        "btnDeleteUndo": "Annuler",
	        "btnDeleteConfirm": "Confirmer",
	        "dataEditEnd": "Enregistrer",
	        //2.0
	        "btnSave" : "Enregistrer",
	        "btnUpdateResource" : "Actualiser la ressource",
	
	
	        //Headers
	        "DManHeader": "Gestion des Données FENIX",
	        "DManResHeader": "Éditer la Ressource",
	        "MetaHeader": "Éditeur des Métadonnées",
	        "MetaCopyHeader": "Copier les métadonnées à partir de:",
	        "MetaCopyAlt": "Copier les métadonnées",
	        "DSDHeader": "Éditeur de la Définition de la Structure des Données",
	        "DataHeader": "Éditeur des Données",
	        "CloseHeader": "Ressource fermée",
	        "DeleteHeader": "Voulez-vous supprimer la ressource?",
	
	
	        //Descriptions
	        "DManIntro": "La gestion des données est le processus de contrôle des informations générées lors d'un projet de recherche. Toutes les recherches nécessiteront d'un certain niveau de gestion des données, et les organismes de financement sont de plus en plus exigeant que les chercheurs planifient et exécutent des bonnes pratiques de gestion des données.",
	        "CopyMetaRID": "Code d'identification de la Ressource",
	        "CopyMetaVer": "Version de la Ressource (le cas échéant)",
	        "NoTitle": "Sans Titre",
	        "CopyDSD" : "Copier le DSD à partir de:",
	        "CopyDSDAlt" : "Copier le DSD",
	
	        metadataValidationWarning : "Veuillez remplir les champs obligatoires",
	
	        //DSD
	        DSD_COPY_SUCCESS : "DSD copié avec succès",
	        DSD_COPY_EMPTY_RESOURCE : "La ressource ne contient pas de colonnes",
	        DSD_MINIMUM: "Au moins une colonne est nécessaire pour enregistrer le DSD",
	
	        //Metadata
	        METADATA_COPY_EMPTY_RESOURCE : "Ressource introuvable",
	        METADATA_COPY_SUCCESS : "Métadonnées copiées avec succès",
	
	        //DATA
	        CSVSEPARATOR : "Veuillez sélectionner un séparateur du CSV"
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <div class=\"datamng-welcome\">\r\n\r\n            <h3 id=\"DManHeader\">"
	    + alias4(((helper = (helper = helpers.dManHeader || (depth0 != null ? depth0.dManHeader : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dManHeader","hash":{},"data":data}) : helper)))
	    + "</h3>\r\n            <p id=\"DManIntro\">"
	    + alias4(((helper = (helper = helpers.dManIntro || (depth0 != null ? depth0.dManIntro : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dManIntro","hash":{},"data":data}) : helper)))
	    + "</p>\r\n\r\n            <button id=\"btnSearch\" class=\"btn btn-default fx-button-primary-color\" title=\""
	    + alias4(((helper = (helper = helpers.searchBtn || (depth0 != null ? depth0.searchBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"searchBtn","hash":{},"data":data}) : helper)))
	    + "\"> "
	    + alias4(((helper = (helper = helpers.searchBtn || (depth0 != null ? depth0.searchBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"searchBtn","hash":{},"data":data}) : helper)))
	    + " </button>\r\n\r\n            <button id=\"btnAdd\" class=\"btn btn-default fx-button-primary-color\" title=\""
	    + alias4(((helper = (helper = helpers.addBtn || (depth0 != null ? depth0.addBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"addBtn","hash":{},"data":data}) : helper)))
	    + "\"> "
	    + alias4(((helper = (helper = helpers.addBtn || (depth0 != null ? depth0.addBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"addBtn","hash":{},"data":data}) : helper)))
	    + " </button>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n";
	},"useData":true});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(13)['default'];


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _handlebarsBase = __webpack_require__(14);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(28);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(16);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(15);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(29);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(30);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(15);
	
	var _exception = __webpack_require__(16);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(17);
	
	var _decorators = __webpack_require__(25);
	
	var _logger = __webpack_require__(27);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var VERSION = '4.1.2';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;
	
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  try {
	    if (loc) {
	      this.lineNumber = line;
	
	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (Object.defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _helpersBlockHelperMissing = __webpack_require__(18);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(19);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(20);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(21);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(22);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(23);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(24);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(15);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(15);
	
	var _exception = __webpack_require__(16);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;
	
	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvZWFjaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O3FCQUErRSxVQUFVOzt5QkFDbkUsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxNQUFNLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3pELFFBQUksQ0FBQyxPQUFPLEVBQUU7QUFDWixZQUFNLDJCQUFjLDZCQUE2QixDQUFDLENBQUM7S0FDcEQ7O0FBRUQsUUFBSSxFQUFFLEdBQUcsT0FBTyxDQUFDLEVBQUU7UUFDZixPQUFPLEdBQUcsT0FBTyxDQUFDLE9BQU87UUFDekIsQ0FBQyxHQUFHLENBQUM7UUFDTCxHQUFHLEdBQUcsRUFBRTtRQUNSLElBQUksWUFBQTtRQUNKLFdBQVcsWUFBQSxDQUFDOztBQUVoQixRQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUMvQixpQkFBVyxHQUFHLHlCQUFrQixPQUFPLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDO0tBQ2pGOztBQUVELFFBQUksa0JBQVcsT0FBTyxDQUFDLEVBQUU7QUFBRSxhQUFPLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUFFOztBQUUxRCxRQUFJLE9BQU8sQ0FBQyxJQUFJLEVBQUU7QUFDaEIsVUFBSSxHQUFHLG1CQUFZLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNsQzs7QUFFRCxhQUFTLGFBQWEsQ0FBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRTtBQUN6QyxVQUFJLElBQUksRUFBRTtBQUNSLFlBQUksQ0FBQyxHQUFHLEdBQUcsS0FBSyxDQUFDO0FBQ2pCLFlBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0FBQ25CLFlBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxLQUFLLENBQUMsQ0FBQztBQUN6QixZQUFJLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUM7O0FBRW5CLFlBQUksV0FBVyxFQUFFO0FBQ2YsY0FBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLEdBQUcsS0FBSyxDQUFDO1NBQ3hDO09BQ0Y7O0FBRUQsU0FBRyxHQUFHLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFO0FBQzdCLFlBQUksRUFBRSxJQUFJO0FBQ1YsbUJBQVcsRUFBRSxtQkFBWSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRSxLQUFLLENBQUMsRUFBRSxDQUFDLFdBQVcsR0FBRyxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUM7T0FDL0UsQ0FBQyxDQUFDO0tBQ0o7O0FBRUQsUUFBSSxPQUFPLElBQUksT0FBTyxPQUFPLEtBQUssUUFBUSxFQUFFO0FBQzFDLFVBQUksZUFBUSxPQUFPLENBQUMsRUFBRTtBQUNwQixhQUFLLElBQUksQ0FBQyxHQUFHLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRTtBQUN2QyxjQUFJLENBQUMsSUFBSSxPQUFPLEVBQUU7QUFDaEIseUJBQWEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsS0FBSyxPQUFPLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO1dBQy9DO1NBQ0Y7T0FDRixNQUFNO0FBQ0wsWUFBSSxRQUFRLFlBQUEsQ0FBQzs7QUFFYixhQUFLLElBQUksR0FBRyxJQUFJLE9BQU8sRUFBRTtBQUN2QixjQUFJLE9BQU8sQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLEVBQUU7Ozs7QUFJL0IsZ0JBQUksUUFBUSxLQUFLLFNBQVMsRUFBRTtBQUMxQiwyQkFBYSxDQUFDLFFBQVEsRUFBRSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7YUFDaEM7QUFDRCxvQkFBUSxHQUFHLEdBQUcsQ0FBQztBQUNmLGFBQUMsRUFBRSxDQUFDO1dBQ0w7U0FDRjtBQUNELFlBQUksUUFBUSxLQUFLLFNBQVMsRUFBRTtBQUMxQix1QkFBYSxDQUFDLFFBQVEsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO1NBQ3RDO09BQ0Y7S0FDRjs7QUFFRCxRQUFJLENBQUMsS0FBSyxDQUFDLEVBQUU7QUFDWCxTQUFHLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ3JCOztBQUVELFdBQU8sR0FBRyxDQUFDO0dBQ1osQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoiZWFjaC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7YXBwZW5kQ29udGV4dFBhdGgsIGJsb2NrUGFyYW1zLCBjcmVhdGVGcmFtZSwgaXNBcnJheSwgaXNGdW5jdGlvbn0gZnJvbSAnLi4vdXRpbHMnO1xuaW1wb3J0IEV4Y2VwdGlvbiBmcm9tICcuLi9leGNlcHRpb24nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignZWFjaCcsIGZ1bmN0aW9uKGNvbnRleHQsIG9wdGlvbnMpIHtcbiAgICBpZiAoIW9wdGlvbnMpIHtcbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ011c3QgcGFzcyBpdGVyYXRvciB0byAjZWFjaCcpO1xuICAgIH1cblxuICAgIGxldCBmbiA9IG9wdGlvbnMuZm4sXG4gICAgICAgIGludmVyc2UgPSBvcHRpb25zLmludmVyc2UsXG4gICAgICAgIGkgPSAwLFxuICAgICAgICByZXQgPSAnJyxcbiAgICAgICAgZGF0YSxcbiAgICAgICAgY29udGV4dFBhdGg7XG5cbiAgICBpZiAob3B0aW9ucy5kYXRhICYmIG9wdGlvbnMuaWRzKSB7XG4gICAgICBjb250ZXh0UGF0aCA9IGFwcGVuZENvbnRleHRQYXRoKG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCwgb3B0aW9ucy5pZHNbMF0pICsgJy4nO1xuICAgIH1cblxuICAgIGlmIChpc0Z1bmN0aW9uKGNvbnRleHQpKSB7IGNvbnRleHQgPSBjb250ZXh0LmNhbGwodGhpcyk7IH1cblxuICAgIGlmIChvcHRpb25zLmRhdGEpIHtcbiAgICAgIGRhdGEgPSBjcmVhdGVGcmFtZShvcHRpb25zLmRhdGEpO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIGV4ZWNJdGVyYXRpb24oZmllbGQsIGluZGV4LCBsYXN0KSB7XG4gICAgICBpZiAoZGF0YSkge1xuICAgICAgICBkYXRhLmtleSA9IGZpZWxkO1xuICAgICAgICBkYXRhLmluZGV4ID0gaW5kZXg7XG4gICAgICAgIGRhdGEuZmlyc3QgPSBpbmRleCA9PT0gMDtcbiAgICAgICAgZGF0YS5sYXN0ID0gISFsYXN0O1xuXG4gICAgICAgIGlmIChjb250ZXh0UGF0aCkge1xuICAgICAgICAgIGRhdGEuY29udGV4dFBhdGggPSBjb250ZXh0UGF0aCArIGZpZWxkO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIHJldCA9IHJldCArIGZuKGNvbnRleHRbZmllbGRdLCB7XG4gICAgICAgIGRhdGE6IGRhdGEsXG4gICAgICAgIGJsb2NrUGFyYW1zOiBibG9ja1BhcmFtcyhbY29udGV4dFtmaWVsZF0sIGZpZWxkXSwgW2NvbnRleHRQYXRoICsgZmllbGQsIG51bGxdKVxuICAgICAgfSk7XG4gICAgfVxuXG4gICAgaWYgKGNvbnRleHQgJiYgdHlwZW9mIGNvbnRleHQgPT09ICdvYmplY3QnKSB7XG4gICAgICBpZiAoaXNBcnJheShjb250ZXh0KSkge1xuICAgICAgICBmb3IgKGxldCBqID0gY29udGV4dC5sZW5ndGg7IGkgPCBqOyBpKyspIHtcbiAgICAgICAgICBpZiAoaSBpbiBjb250ZXh0KSB7XG4gICAgICAgICAgICBleGVjSXRlcmF0aW9uKGksIGksIGkgPT09IGNvbnRleHQubGVuZ3RoIC0gMSk7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBsZXQgcHJpb3JLZXk7XG5cbiAgICAgICAgZm9yIChsZXQga2V5IGluIGNvbnRleHQpIHtcbiAgICAgICAgICBpZiAoY29udGV4dC5oYXNPd25Qcm9wZXJ0eShrZXkpKSB7XG4gICAgICAgICAgICAvLyBXZSdyZSBydW5uaW5nIHRoZSBpdGVyYXRpb25zIG9uZSBzdGVwIG91dCBvZiBzeW5jIHNvIHdlIGNhbiBkZXRlY3RcbiAgICAgICAgICAgIC8vIHRoZSBsYXN0IGl0ZXJhdGlvbiB3aXRob3V0IGhhdmUgdG8gc2NhbiB0aGUgb2JqZWN0IHR3aWNlIGFuZCBjcmVhdGVcbiAgICAgICAgICAgIC8vIGFuIGl0ZXJtZWRpYXRlIGtleXMgYXJyYXkuXG4gICAgICAgICAgICBpZiAocHJpb3JLZXkgIT09IHVuZGVmaW5lZCkge1xuICAgICAgICAgICAgICBleGVjSXRlcmF0aW9uKHByaW9yS2V5LCBpIC0gMSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBwcmlvcktleSA9IGtleTtcbiAgICAgICAgICAgIGkrKztcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHByaW9yS2V5ICE9PSB1bmRlZmluZWQpIHtcbiAgICAgICAgICBleGVjSXRlcmF0aW9uKHByaW9yS2V5LCBpIC0gMSwgdHJ1ZSk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBpZiAoaSA9PT0gMCkge1xuICAgICAgcmV0ID0gaW52ZXJzZSh0aGlzKTtcbiAgICB9XG5cbiAgICByZXR1cm4gcmV0O1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _exception = __webpack_require__(16);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(15);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    if (!obj) {
	      return obj;
	    }
	    if (field === 'constructor' && !obj.propertyIsEnumerable(field)) {
	      return undefined;
	    }
	    return obj[field];
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFFBQUksQ0FBQyxHQUFHLEVBQUU7QUFDUixhQUFPLEdBQUcsQ0FBQztLQUNaO0FBQ0QsUUFBSSxLQUFLLEtBQUssYUFBYSxJQUFJLENBQUMsR0FBRyxDQUFDLG9CQUFvQixDQUFDLEtBQUssQ0FBQyxFQUFFO0FBQy9ELGFBQU8sU0FBUyxDQUFDO0tBQ2xCO0FBQ0QsV0FBTyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUM7R0FDbkIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9va3VwLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvb2t1cCcsIGZ1bmN0aW9uKG9iaiwgZmllbGQpIHtcbiAgICBpZiAoIW9iaikge1xuICAgICAgcmV0dXJuIG9iajtcbiAgICB9XG4gICAgaWYgKGZpZWxkID09PSAnY29uc3RydWN0b3InICYmICFvYmoucHJvcGVydHlJc0VudW1lcmFibGUoZmllbGQpKSB7XG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH1cbiAgICByZXR1cm4gb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(15);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _decoratorsInline = __webpack_require__(26);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(15);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(15);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(15);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(16);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(14);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: Object.seal({}),
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);
	
	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function ( ) {
	
	    'use strict';
	
	    var prefix = "";
	
	    return {
	
	        MISSING_CONTAINER : prefix + "missing_container",
	        MISSING_BUTTONS : prefix + "missing_button",
	
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	
	    'use strict';
	
	    return {
	
	        RESOURCE_LOAD : "RESOURCE_LOAD",
	        RESOURCE_LOADED: "RESOURCE_LOADED",
	        RESOURCE_UPDATED: "RESOURCE_UPDATED",
	        RESOURCE_UNLOADED: "RESOURCE_UNLOADED",
	        RESOURCE_DELETE: "RESOURCE_DELETE",
	        RESOURCE_DELETE_UNDO: "RESOURCE_DELETE_UNDO",
	        RESOURCE_DELETED: "RESOURCE_DELETED",
	        RESOURCE_CREATED: "RESOURCE_CREATED",
	
	        SHOW_METADATA: "SHOW_METADATA",
	        SHOW_DSD: "SHOW_DSD",
	        SHOW_DATA: "SHOW_DATA",
	        SHOW_SEARCH: "SHOW_SEARCH",
	        SHOW_ADD: "SHOW_ADD",
	
	        METADATA_CREATE : "METADATA_CREATE",
	        METADATA_SAVE : "METADATA_SAVE",
	        METADATA_INFO : "METADATA_INFO",
	        METADATA_DELETE: "METADATA_DELETE",
	
	        METADATA_COPY_EMPTY_RESOURCE : "METADATA_COPY_EMPTY_RESOURCE",
	        METADATA_COPY_SUCCESS : "METADATA_COPY_SUCCESS",
	
	        DSD_INFO : "METADATA_INFO",
	        DSD_SAVE : "DSD_SAVE",
	        DSD_COPY_EMPTY_RESOURCE : "DSD_COPY_EMPTY_RESOURCE",
	        DSD_COPY_SUCCESS : "DSD_COPY_SUCCESS"
	
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_34__;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	
	    'use strict';
	
	    return {
	        errors: {
	            "closeButton": true,
	            "debug": false,
	            "newestOnTop": false,
	            "positionClass": "toast-top-right",
	            "preventDuplicates": false,
	            "onclick": null,
	            "showDuration": "300",
	            "hideDuration": "1000",
	            "timeOut": "0",
	            "extendedTimeOut": "0",
	            "showEasing": "swing",
	            "hideEasing": "linear",
	            "showMethod": "fadeIn",
	            "hideMethod": "fadeOut"
	        },
	        info : {
	            "closeButton": false,
	            "debug": false,
	            "newestOnTop": false,
	            //"progressBar": true,
	            "positionClass": "toast-top-right",
	            "preventDuplicates": false,
	            "onclick": null,
	            "showDuration": "300",
	            "hideDuration": "1000",
	            "timeOut": "2500",
	            "extendedTimeOut": "1000",
	            "showEasing": "swing",
	            "hideEasing": "linear",
	            "showMethod": "fadeIn",
	            "hideMethod": "fadeOut"
	        }
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	        'use strict';
	
	        return {
	            '(/)': 'onLanding',
	            '(/)landing(/)': 'onLanding',
	
	            '(/)home(/)': 'onHome',
	            '(/)add(/)': 'onAdd',
	
	            '(/)metadata(/)': 'onMetadata',
	            '(/)dsd(/)': 'onDSD',
	            '(/)data(/)': 'onData',
	
	            '(/)close(/)' : 'onClose',
	            '(/)delete(/)': 'onDelete',
	            '(/)search(/)': 'onSearch',
	            '(/)not-found(/)': 'onNotFound',
	
	            '(/)denied(/)': 'onDenied',
	
	            // fallback route
	            '(/)*path': 'onDefaultRoute'
	        }
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	        'use strict';
	
	       return {
	           lang : "EN",
	
	           config: {
	               contextSystem :"fenix_develop",
	               datasources : ["D3S"],
	               resourceRepresentationType: "dataset"
	           },
	
	           copyMeta: true,
	           copyDSD: true,
	
	           menuItems : ['home', 'landing', 'search', 'add', 'metadata', 'dsd', 'data', 'delete', 'close'],
	           menuItemsEnabledOnStart : ['add', 'search', 'landing'],
	           menuItemsEnableOnValidResource : ['delete', 'metadata', 'dsd', 'data', 'home', 'close']
	       };
	
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_38__;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	        "items": [
	            {
	                "attrs": {
	                    "id": "landing"
	                },
	                "label": {
	                    "EN": "Data Management",
	                    "FR": "Gestion des Données"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "search"
	                },
	                "label": {
	                    "EN": "Search",
	                    "FR": "Rechercher"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "add"
	                },
	                "label": {
	                    "EN": "Add",
	                    "FR": "Ajouter"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "home"
	                },
	                "label": {
	                    "EN": "Home",
	                    "FR": "Accueil"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "metadata"
	                },
	                "label": {
	                    "EN": "Metadata",
	                    "FR": "Métadonnées"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "dsd"
	                },
	                "label": {
	                    "EN": "DSD",
	                    "FR": "DSD"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "data"
	                },
	                "label": {
	                    "EN": "Data",
	                    "FR": "Données"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "delete"
	                },
	                "label": {
	                    "EN": "Delete",
	                    "FR": "Supprimer"
	                }
	            },
	            {
	                "attrs": {
	                    "id": "close"
	                },
	                "label": {
	                    "EN": "Close",
	                    "FR": "Terminer"
	                }
	            }
	        ],
	        "languages": [],
	        "active": [
	            "landing",
	            "search"
	        ]
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3),
	    __webpack_require__(41),
	    __webpack_require__(2),
	    __webpack_require__(42),
	    __webpack_require__(31),
	    __webpack_require__(32),
	    __webpack_require__(43)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log, Catalog, CatalogConfig, Bridge, ERR, EVT, template) {
	    "use strict";
	
	    var s = {
	        CATALOG: "#catalog-container"
	    };
	
	    var SearchView = Backbone.View.extend({
	
	        render: function (o) {
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	                log.info("Rendering View - Search", this);
	
	                this._attach();
	
	                this._initCatalog();
	
	                this._bindEventListeners();
	
	                return this;
	            } else {
	                log.error("Impossible to render Search");
	                log.error(valid)
	            }
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	
	            this.cache = this.initial.cache;
	            this.environment = this.initial.environment;
	            this.lang = this.initial.lang.toLowerCase();
	            this.serviceProvider = this.initial.serviceProvider || undefined ;
	
	            this.catalogConfig = $.extend(true, CatalogConfig, this.initial.catalog);
	        },
	
	        _attach: function () {
	
	            this.$el.html(template);
	        },
	
	        _initCatalog: function () {
	
	            var model = $.extend(true, {
	                el: this.$el.find(s.CATALOG),
	                cache: this.cache,
	                lang: this.lang,
	                environment: this.environment
	            }, this.catalogConfig);
	
	            this.catalog = new Catalog(model);
	
	            console.log("this model: ", model);
	        },
	
	        _bindEventListeners: function () {
	            log.info("{SEARCH} bindEventListeners()");
	
	            this.catalog.on('select', function (payload) {
	
	                log.info("*select* triggered");
	
	                Backbone.trigger(EVT.RESOURCE_LOAD, payload);
	            });
	        },
	
	        remove: function () {
	            this.catalog.dispose();
	
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	
	    });
	
	    return SearchView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_41__;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_42__;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div data-role=\"modal\" class=\"modal fade catalog-modal catalog-dm\" tabindex=\"-1\" role=\"dialog\"\r\n     aria-labelledby=\"analysisCatalog\">\r\n    <div class=\"modal-dialog modal-lg\">\r\n        <div class=\"modal-content\">\r\n\r\n            <div id=\"catalog-container\"></div>\r\n\r\n        </div>\r\n    </div>\r\n</div>";
	},"useData":true});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log) {
	
	    "use strict";
	
	    var NotFoundView = Backbone.View.extend({
	
	        render: function (o) {
	
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("Rendering View - Not Found", this);
	
	                this._attach();
	                return this;
	            } else {
	                log.error("Impossible to render Not Found");
	                log.error(valid)
	            }
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	
	            this.lang = this.initial.lang.toLowerCase();
	        },
	
	        _attach: function () {
	            this.$el.html("<h1>Oh snap! Error 404</h1>");
	        },
	
	        remove: function () {
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	
	    });
	
	    return NotFoundView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(8),
	    __webpack_require__(47),
	    __webpack_require__(32)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log, Q, labels, template, EVT) {
	
	    "use strict";
	
	    var s = {
	        HEADER: "#DeleteHeader",
	        BTN_CONFIRM: "#btnDeleteConfirm",
	        BTN_UNDO: "#btnDeleteUndo"
	    };
	
	    var DeleteView = Backbone.View.extend({
	
	        render: function (o) {
	
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("Rendering View - Delete", o);
	
	                this._attach();
	
	                this._initVariables();
	
	                this._bindEventListeners();
	
	                return this;
	            } else {
	                log.error("Impossible to render Landing");
	                log.error(valid)
	            }
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	            this.lang = this.initial.lang.toLowerCase();
	        },
	
	        _attach: function () {
	            this.$el.html(template({
	                header: labels[this.lang]['DeleteHeader'],
	                confirm: labels[this.lang]['btnDeleteConfirm'],
	                undo: labels[this.lang]['btnDeleteUndo']
	            }));
	        },
	
	        _initVariables: function () {
	
	            this.$confirmButton = this.$el.find(s.BTN_CONFIRM);
	            this.$undoButton = this.$el.find(s.BTN_UNDO);
	            this.deleteMetadata = this.initial.deleteMetadata || false;
	            log.info("Delete Metadata is ",this.deleteMetadata);
	        },
	
	        _bindEventListeners: function () {
	            log.info("{DELETE} bindEventListeners()");
	            var self = this;
	            this.$confirmButton.on("click", function () {
	                if (self.deleteMetadata) {
	                    Backbone.trigger(EVT.METADATA_DELETE)
	                } else {
	                    Backbone.trigger(EVT.RESOURCE_DELETE);
	                }
	            });
	
	            this.$undoButton.on("click", function () {
	                Backbone.trigger(EVT.RESOURCE_DELETE_UNDO);
	            });
	
	        },
	
	        _unbindEventListeners: function () {
	            this.$confirmButton.off();
	            this.$undoButton.off();
	        },
	
	        accessControl: function (Resource) {
	
	            return new Q.Promise(function (fulfilled, rejected) {
	                if (!$.isEmptyObject(Resource)) {
	                    fulfilled();
	                } else {
	                    rejected();
	                }
	            });
	        },
	
	        remove: function () {
	            this._unbindEventListeners();
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return DeleteView;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_46__;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"row\">\r\n    <div class=\"col-md-4 col-md-offset-4\">\r\n        <div class=\"datamng-welcome\">\r\n            <h3 id=\"DeleteHeader\">"
	    + alias4(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"header","hash":{},"data":data}) : helper)))
	    + "</h3>\r\n            <div class=\"btn-group btn-group-justified\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button id=\"btnDeleteConfirm\" title=\""
	    + alias4(((helper = (helper = helpers.confirm || (depth0 != null ? depth0.confirm : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"confirm","hash":{},"data":data}) : helper)))
	    + "\" class=\"btn btn-default\"> "
	    + alias4(((helper = (helper = helpers.confirm || (depth0 != null ? depth0.confirm : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"confirm","hash":{},"data":data}) : helper)))
	    + "</button>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button id=\"btnDeleteUndo\" title=\""
	    + alias4(((helper = (helper = helpers.undo || (depth0 != null ? depth0.undo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"undo","hash":{},"data":data}) : helper)))
	    + "\" class=\"btn btn-default fx-button-primary-color\"> "
	    + alias4(((helper = (helper = helpers.undo || (depth0 != null ? depth0.undo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"undo","hash":{},"data":data}) : helper)))
	    + "</button>\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n";
	},"useData":true});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(33),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(50),
	    __webpack_require__(49),
	    __webpack_require__(42),
	    __webpack_require__(51),
	    __webpack_require__(32),
	    __webpack_require__(8),
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, _, log, Q, MDE, Filter, Bridge, template, EVT, labels) {
	
	    "use strict";
	
	    var s = {
	        SAVE_BUTTON: '[data-role="save"]',
	        METADATA: '[data-role="metadata"]',
	        COPY_FORM: "[data-role='form']",
	        COPY_BUTTON: "[data-role='copy']"
	    };
	
	    var MetadataView = Backbone.View.extend({
	
	        render: function (o) {
	            $.extend(true, this, {initial: o});
	
	            console.log(this.initial);
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("Rendering View - Metadata", this);
	
	                this._attach();
	
	                this._initVariables();
	
	                this._initComponents();
	
	                this._bindEventListeners();
	
	                return this;
	            } else {
	                log.error("Impossible to render Metadata");
	                log.error(valid)
	            }
	        },
	
	        _initComponents : function() {
	
	            this.bridge = new Bridge({
	                cache: this.cache,
	                environment: this.environment,
	                serviceProvider : this.serviceProvider
	            });
	
	            this._initMetadataEditor();
	
	            this._initCopyMetadata();
	
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	
	            this.environment = this.initial.environment;
	            this.lang = this.initial.lang.toLowerCase();
	            this.model = this.initial.model;
	            this.config = this.initial.config;
	            this.label = this.initial.label || "";
	            this.copy = (this.initial.copy === undefined) ? true : this.initial.copy;
	            this.converters = this.initial.converters;
	
	            this.serviceProvider = this.initial.serviceProvider || undefined ;
	
	        },
	
	        _attach: function () {
	            this.$el.html(template({
	                lblMeta: this.label,
	                label: (this.label.length),
	                copyTitle: labels[this.lang]['MetaCopyHeader'],
	                copyAlt: labels[this.lang]['MetaCopyAlt'],
	                saveBtn: labels[this.lang]['btnUpdateResource'],
	                copyMeta: this.copy
	            }));
	        },
	
	        _initVariables: function () {
	            this.$savebtn = this.$el.find(s.SAVE_BUTTON);
	            this.$copyButton = this.$el.find(s.COPY_BUTTON);
	        },
	
	        _bindEventListeners: function () {
	            this.$savebtn.on("click", _.bind(this._onSaveClick, this));
	            this.$copyButton.on("click", _.bind(this._onCopyClick, this));
	        },
	
	        _onSaveClick : function () {
	
	            var values = this.MDE.getValues();
	
	            log.info("Metadata values:");
	            log.info(values);
	
	
	            if (!values.hasOwnProperty("valid")) {
	                if (values.uid === undefined ) {
	                    Backbone.trigger(EVT.METADATA_CREATE, values);
	                } else {
	                    Backbone.trigger(EVT.METADATA_SAVE, values);
	                }
	            } else {
	                Backbone.trigger(EVT.METADATA_INFO, "metadataValidationWarning");
	            }
	
	        },
	
	        _onCopyClick: function (e) {
	            e.stopPropagation();
	
	            var values = this.copyForm.getValues(),
	                uid = values.values.uid[0],
	                version = values.values.version[0];
	
	            if (values.valid === true) {
	
	                this.bridge.getResource({
	                    uid: uid,
	                    version: version,
	                    params: {
	                        full: true,
	                        dsd: true,
	                        export: true
	                    }
	                }).then(
	                    _.bind(function (resource) {
	
	                        if (!resource) {
	                            Backbone.trigger(EVT.METADATA_COPY_EMPTY_RESOURCE);
	                        } else {
	
	                            var metadata = resource.metadata || {};
	
	                            delete metadata.uid;
	
	                            delete metadata.version;
	
	                            delete metadata.title;
	
	                            this.MDE.setValues(metadata);
	
	                            Backbone.trigger(EVT.METADATA_COPY_SUCCESS);
	                        }
	
	                    }, this),
	                    _.bind(function (msg) {
	                        Backbone.trigger("error:showerrormsg", msg);
	
	                    }, this)
	                );
	            }
	
	        },
	
	        _initCopyMetadata: function () {
	
	            this.copyForm = new Filter({
	                el: this.$el.find(s.COPY_FORM),
	                selectors: {
	                    uid: {
	                        selector: {
	                            id: "input",
	                            type: "text"
	                        },
	                        constraints: {
	                            presence: true
	                        },
	                        template: {
	                            title: "UID"
	                        }
	                    },
	                    version: {
	                        selector: {
	                            id: "input",
	                            type: "text"
	                        },
	                        template: {
	                            title: "Version"
	                        }
	                    }
	                }
	            })
	
	        },
	
	        _initMetadataEditor: function () {
	            log.info("{MDE} initViews");
	
	            var model = {
	                el: s.METADATA,
	                lang: this.lang,
	                config: this.config,
	                cache: this.cache,
	                converters: this.converters,
	                environment: this.environment,
	                serviceProvider: this.serviceProvider,
	                model: this.model
	            };
	
	            log.info("Metadata editor model:");
	            log.info(model);
	
	            this.MDE = new MDE(model);
	
	        },
	
	        accessControl: function (Resource) {
	
	            return new Q.Promise(function (fulfilled, rejected) {
	                if (!$.isEmptyObject(Resource)) {
	                    fulfilled();
	                } else {
	                    rejected();
	                }
	            });
	        },
	
	        _unbindEventListeners: function () {
	            this.$savebtn.off("click");
	        },
	
	        remove: function () {
	            this._unbindEventListeners();
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return MetadataView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_49__;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_50__;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <button data-role=\"save\" type=\"button\" class=\"pull-right btn btn-default fx-button-primary-color\" title=\""
	    + alias4(((helper = (helper = helpers.lblMeta || (depth0 != null ? depth0.lblMeta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblMeta","hash":{},"data":data}) : helper)))
	    + "\" aria-label=\"Left Align\">\r\n                "
	    + alias4(((helper = (helper = helpers.lblMeta || (depth0 != null ? depth0.lblMeta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblMeta","hash":{},"data":data}) : helper)))
	    + "\r\n            </button>\r\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <button data-role=\"save\" type=\"button\" class=\"pull-right btn btn-floating fx-background-color-primary-color\"\r\n                    title=\""
	    + container.escapeExpression(((helper = (helper = helpers.saveBtn || (depth0 != null ? depth0.saveBtn : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"saveBtn","hash":{},"data":data}) : helper)))
	    + "\"\r\n                    aria-label=\"Left Align\">\r\n                <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n            </button>\r\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "        <div class=\"dropdown\">\r\n\r\n            <button type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\r\n                    id=\"fx-data-management-copy-metadata\" title=\""
	    + alias4(((helper = (helper = helpers.copyAlt || (depth0 != null ? depth0.copyAlt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyAlt","hash":{},"data":data}) : helper)))
	    + "\"\r\n                    class=\"pull-left btn btn-floating fx-background-color-primary-color\">\r\n                <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>\r\n            </button>\r\n\r\n            <div class=\"dropdown-menu fx-padding\" aria-labelledby=\"dLabel\">\r\n                <h6>"
	    + alias4(((helper = (helper = helpers.copyTitle || (depth0 != null ? depth0.copyTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyTitle","hash":{},"data":data}) : helper)))
	    + "</h6>\r\n                <div data-role=\"form\"></div>\r\n                <button data-role=\"copy\" type=\"button\"\r\n                        title=\""
	    + alias4(((helper = (helper = helpers.copyAlt || (depth0 != null ? depth0.copyAlt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyAlt","hash":{},"data":data}) : helper)))
	    + "\"\r\n                        class=\"btn btn-floating fx-background-color-primary-color pull-right\"\r\n                        aria-label=\"Left Align\">\r\n                    <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.label : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + "\r\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.copyMeta : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <div data-role=\"metadata\"></div>\r\n\r\n    </div>\r\n</div>\r\n";
	},"useData":true});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(33),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(53),
	    __webpack_require__(49),
	    __webpack_require__(42),
	    __webpack_require__(54),
	    __webpack_require__(32),
	    __webpack_require__(8),
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, _, log, Q, DsdEditor, Filter, Bridge, template, EVT, labels) {
	
	    "use strict";
	
	    var s = {
	        SAVE_BUTTON: '[data-role="save"]',
	        DSD_EL: '[data-role="dsd"]',
	        COPY_FORM: "[data-role='form']",
	        COPY_BUTTON: "[data-role='copy']"
	    };
	
	    var DSDView = Backbone.View.extend({
	
	        render: function (o) {
	
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("Rendering View - DSD", this);
	
	                this._attach();
	
	                this._initVariables();
	
	                this._initComponents();
	
	                this._bindEventListeners();
	
	                return this;
	            } else {
	                log.error("Impossible to render DSD");
	                log.error(valid)
	            }
	        },
	
	        _attach: function () {
	            this.$el.html(template({
	                isEditable: this.isEditable,
	                copyTitle:  labels[this.lang]['CopyDSD'],
	                copyAlt: labels[this.lang]['CopyDSDAlt'],
	                saveBtn: labels[this.lang]['btnUpdateResource']
	            }));
	        },
	
	        _initComponents: function () {
	
	            this.bridge = new Bridge({
	                cache: this.cache,
	                environment: this.environment,
	                serviceProvider : this.serviceProvider
	            });
	
	            this._initDsdEditor();
	
	            this._initCopyDsd();
	
	        },
	        _initVariables: function () {
	            this.$saveButton = this.$el.find(s.SAVE_BUTTON);
	            this.$copyButton = this.$el.find(s.COPY_BUTTON);
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	            this.environment = this.initial.environment;
	            this.lang = this.initial.lang.toLowerCase();
	            this.config = this.initial.config;
	            this.model = this.initial.model;
	            this.isEditable = this.initial.isEditable;
	            this.serviceProvider = this.initial.serviceProvider || undefined ;
	        },
	
	        _initDsdEditor: function () {
	            log.info("{DSD} initViews");
	
	            var self = this;
	            this.dsd = DsdEditor;
	            this.dsd.init(this.$el.find(s.DSD_EL), this.config, null);
	
	            if (this.model && Array.isArray(this.model.columns) && this.model.columns.length > 0) {
	                this.dsd.set(this.model.columns);
	            }
	
	            log.info('{DSD} is editable', this.isEditable);
	
	            this.dsd.editable(this.isEditable);
	
	            this.dsd.on("dsd:columnsumary", function(){
	                self.$saveButton.prop("disabled", false);
	            });
	
	            this.dsd.on("dsd:columneditor", function(){
	                self.$saveButton.prop("disabled", true);
	            });
	
	            this.dsd.on("error:showerrormsg", function (msg) {
	                Backbone.trigger("error:showerrormsg", msg);
	            });
	
	        },
	
	        _initCopyDsd: function () {
	
	            this.copyForm = new Filter({
	                el: this.$el.find(s.COPY_FORM),
	                selectors: {
	                    uid: {
	                        selector: {
	                            id: "input",
	                            type: "text"
	                        },
	                        constraints: {
	                            presence: true
	                        },
	                        template: {
	                            title: "UID"
	                        }
	                    },
	                    version: {
	                        selector: {
	                            id: "input",
	                            type: "text"
	                        },
	                        template: {
	                            title: "Version"
	                        }
	                    }
	                }
	            })
	
	        },
	
	        _bindEventListeners: function () {
	            log.info("{DSD} bindEventListeners()");
	            this.$saveButton.on("click", _.bind(this._onSaveClick, this));
	            this.$copyButton.on("click", _.bind(this._onCopyClick, this));
	        },
	
	        _onCopyClick: function (e) {
	            e.stopPropagation();
	
	            var values = this.copyForm.getValues(),
	                uid = values.values.uid[0],
	                version = values.values.version[0];
	
	            if (values.valid === true) {
	
	                this.bridge.getResource({
	                    uid: uid,
	                    version: version,
	                    params: {
	                        dsd: true,
	                        export: true
	                    }
	                }).then(
	                    _.bind(function (resource) {
	
	                        var metadata = resource.metadata || {},
	                            dsd = metadata.dsd || {},
	                            columns = dsd.columns || [];
	
	                        if (columns.length > 0) {
	                            this.dsd.set(columns);
	                            Backbone.trigger(EVT.DSD_COPY_SUCCESS);
	                        } else {
	                            Backbone.trigger(EVT.DSD_COPY_EMPTY_RESOURCE);
	                        }
	
	                    }, this),
	                    _.bind(function (msg) {
	                        Backbone.trigger("error:showerrormsg", msg);
	                    }, this)
	                );
	            }
	
	        },
	
	        _onSaveClick: function () {
	
	            if ( this.dsd.validate() ) {
	
	                var obj = {
	                    columns: this.dsd.get(),
	                    datasources: this.config.datasources,
	                    contextSystem: this.config.contextSystem
	                };
	
	                log.info("{DSD} saving", obj);
	
	                if (obj.columns.length > 0) {
	                    Backbone.trigger(EVT.DSD_SAVE, obj);
	                } else {
	                    Backbone.trigger(EVT.DSD_INFO, "DSD_MINIMUM");
	                }
	            }
	
	        },
	
	        _unbindEventListeners: function () {
	            this.$saveButton.off("click");
	        },
	
	        accessControl: function (Resource) {
	
	            return new Q.Promise(function (fulfilled, rejected) {
	                if (!$.isEmptyObject(Resource)) {
	                    fulfilled();
	                } else {
	                    rejected();
	                }
	            });
	        },
	
	        remove: function () {
	            log.info("{DSD} remove");
	
	            this._unbindEventListeners();
	
	            this.dsd.destroy();
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return DSDView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_53__;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"dropdown\">\r\n\r\n                <button id=\"fx-data-management-copy-dsd\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\r\n                        title=\""
	    + alias4(((helper = (helper = helpers.copyAlt || (depth0 != null ? depth0.copyAlt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyAlt","hash":{},"data":data}) : helper)))
	    + "\"\r\n                        class=\"pull-left btn btn-floating fx-background-color-primary-color\">\r\n                    <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>\r\n                </button>\r\n\r\n                <div class=\"dropdown-menu fx-padding\" aria-labelledby=\"dLabel\">\r\n                    <h6>"
	    + alias4(((helper = (helper = helpers.copyTitle || (depth0 != null ? depth0.copyTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyTitle","hash":{},"data":data}) : helper)))
	    + "</h6>\r\n                    <div data-role=\"form\"></div>\r\n                    <button data-role=\"copy\" type=\"button\"\r\n                            title=\""
	    + alias4(((helper = (helper = helpers.copyAlt || (depth0 != null ? depth0.copyAlt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyAlt","hash":{},"data":data}) : helper)))
	    + "\"\r\n                            class=\"btn btn-floating fx-background-color-primary-color pull-right\"\r\n                            aria-label=\"Left Align\">\r\n                        <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n\r\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n\r\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isEditable : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\r\n        <button data-role=\"save\" type=\"button\" class=\"pull-right btn btn-floating fx-background-color-primary-color\"\r\n                title=\""
	    + container.escapeExpression(((helper = (helper = helpers.saveBtn || (depth0 != null ? depth0.saveBtn : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"saveBtn","hash":{},"data":data}) : helper)))
	    + "\"\r\n                aria-label=\"Left Align\">\r\n            <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<hr>\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <div data-role=\"dsd\"></div>\r\n    </div>\r\n</div>";
	},"useData":true});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(56),
	    __webpack_require__(57),
	    __webpack_require__(8),
	    __webpack_require__(58),
	    __webpack_require__(59)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log, Q, DataEditor, FileUploader, labels, template, templateFileUploader) {
	
	    "use strict";
	
	    var rowlimit = null;
	
	    var s = {
	
	        DATA_EL: '[data-role="data"]',
	        SAVE_BUTTON: "[data-role='save']",
	        KEEP_NEW_DATA_BUTTON: "[data-role='keep-new']",
	        KEEP_OLD_DATA_BUTTON: "[data-role='keep-old']",
	        ABORT_MERGE_BUTTON: "[data-role='abort-merge']",
	        CSV_MATCHER_OK: "[data-role='csv-matcher-ok']",
	        CSV_MATCHER_CANCEL: "[data-role='csv-matcher-cancel']",
	
	
	        utility: '#fx-data-management-utility-holder',
	        btnFileUploader: "#btnFileUploader",
	        btnDelAllData: "#btnDelAllData",
	        dataFileUpload: "#dataFUpload",
	        csvSeparator: "#csvSeparator"
	    };
	
	    var p = {
	        lblUpload : "#lblUpload",
	        lblSeparator : "#lblSeparator",
	        csvSeparatorComma : "#csvSeparatorComma",
	        csvSeparatorSemi : "#csvSeparatorSemi"
	    };
	
	    var DataView = Backbone.View.extend({
	
	        render: function (o) {
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("{Data} Rendering View");
	
	                this._attach();
	
	                this._initVariables();
	
	                this._initFileUploader();
	
	                this._initViews();
	
	                this._bindEventListeners();
	
	            } else {
	                log.error("Impossible to render Data");
	                log.error(valid)
	            }
	
	            log.info("{Data} Rendering View", this);
	
	            return this;
	        },
	
	        _parseInput: function () {
	
	            this.environment = this.initial.environment;
	            this.lang = this.initial.lang.toLowerCase();
	            this.cLists = this.initial.codelists;
	            this.dsd = this.initial.dsd;
	            this.data = this.initial.data;
	            this.generator = this.initial.generator;
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _attach: function () {
	            this.$el.html(template({
	                saveBtn: labels[this.lang]['btnUpdateResource']
	            }));
	
	        },
	
	        _initVariables: function () {
	
	            this.$savebtn = this.$el.find(s.SAVE_BUTTON);
	
	            this.$dataEditorEl = this.$el.find(s.DATA_EL);
	
	            this.$utility = this.$el.find(s.utility);
	
	        },
	
	        _initViews: function () {
	            log.info("{Data} initViews");
	
	            var self = this;
	            this.$utility.hide();
	            this.$savebtn.prop("disabled", true);
	
	            DataEditor.init(this.$dataEditorEl, { lang:this.lang }, null);
	
	            DataEditor.on("data:restoreupload", function(){
	                self.$utility.show();
	                self.$savebtn.prop("disabled", false);
	            });
	
	            DataEditor.on("error:showerrormsg", function (msg) {
	                Backbone.trigger("error:showerrormsg", msg);
	            });
	
	            DataEditor.on("data:loaded", function () {
	                self.$utility.show();
	                self.$savebtn.prop("disabled", false);
	                Backbone.trigger("data:loaded");
	            });
	
	            log.info('{Data} Calling the Codelists');
	
	            this.generator.then(function (result) {
	                //Data.isEditable(false);
	
	                self.cLists = result;
	                log.info('{Data} Calling the DSD');//, result);
	                var dsd = self.dsd.columns;
	                log.info('{Data} Setting the DSD...');//, dsd);
	                log.warn(JSON.stringify(dsd));
	                log.warn(JSON.stringify(self.cLists));
	                DataEditor.setColumns(dsd, self.cLists, null);
	                log.info("{Data} DSD Columns Setted.");//, self.data);
	                if (self.data !== undefined) {
	                    DataEditor.setData(self.data, rowlimit);
	                    log.info("{Data} But not the data!");
	                }
	                DataEditor.setStatus('loaded');
	                self.$utility.show();
	                self.$savebtn.prop("disabled", false);
	            })
	
	        },
	
	        _initFileUploader: function () {
	
	
	            this.$utility.html(templateFileUploader({
	                uploadCSV: labels[this.lang]['DatalblUpload'],
	                csvSparator: labels[this.lang]['DatalblSeparator'],
	                csvSeparatorComma: labels[this.lang]['DatalblcsvSeparatorComma'],
	                csvSeparatorSemi: labels[this.lang]['DatalblcsvSeparatorSemi']
	            }));
	
	            this.$btnFileUploader = this.$el.find(s.btnFileUploader);
	            this.$csvSeparator = this.$el.find(s.csvSeparator);
	            this.$lblSeparator = this.$el.find(p.lblSeparator);
	            this.$dataFileUpload = this.$el.find(s.dataFileUpload);
	
	            this.$csvSeparator.on("click", function(e){
	                e.stopPropagation();
	            });
	
	            log.info('init file uploader');
	            this.fUpload = new FileUploader({accept: ['csv']});
	            this.fUpload.render(s.dataFileUpload);
	
	        },
	
	        _bindEventListeners: function () {
	            log.info('{Data} _bindEventListeners');
	            var self = this;
	
	            this.$savebtn.on("click", function () {
	                var exist = DataEditor.getData();
	                log.info("{DATA} saving", exist);
	                if (!!exist) {
	                    Backbone.trigger("data:saving",exist);
	                } else {
	                    Backbone.trigger("error:showerror", labels[this.lang]['invalidData']);
	                }
	            });
	            this.listenTo(Backbone, "data:uploading", function () {
	                log.info("{DATA}[EVT] data:uploading ");
	                DataEditor.setStatus('loading');
	            });
	
	            this.listenTo(Backbone, "data:uploaded", function (str) {
	                log.info("{DATA}[EVT] data:uploaded ");
	                self._csvLoaded(str);
	            });
	        },
	
	        _removeEventListeners: function () {
	
	            this.$savebtn.off();
	        },
	
	        _csvLoaded: function (data) {
	            log.info(' csv loaded ');
	            if (this.$csvSeparator.val() === '') {
	                this.$btnFileUploader.addClass('has-error');
	                this.$lblSeparator.addClass('has-error');
	                Backbone.trigger("error:showerrormsg", labels[this.lang]['CSVSEPARATOR']);
	                this.$dataFileUpload.val('');
	            } else {
	                this.$btnFileUploader.removeClass('has-error');
	                this.$lblSeparator.removeClass('has-error');
	                this.fUpload.reset();
	                this.$utility.hide();
	                this.$savebtn.prop("disabled", true);
	                this.$btnFileUploader.click();
	                DataEditor.csvLoaded(data, {}, this.$csvSeparator.val());
	            }
	        },
	
	        accessControl: function (Resource) {
	
	            return new Q.Promise(function (fulfilled, rejected) {
	                if (!$.isEmptyObject(Resource)) {
	                    fulfilled();
	                } else {
	                    rejected();
	                }
	            });
	        },
	
	        remove: function () {
	            log.warn("{DATA} - Remove View");
	            this._removeEventListeners();
	            DataEditor.destroy();
	            this.$utility.html('');
	            this.$utility.show();
	            this.$savebtn.prop("disabled", false);
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return DataView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_56__;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(3),
	    __webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, log, Backbone) {
	        var widgetName = 'data';
	        var evtTextFileUploading = 'uploading';
	        var evtTextFileUploaded = 'uploaded';
	        var defConfig = {
	            accept: [],
	            maxFileBytes: 0
	        };
	
	        function FileUploadHelper(config) {
	            log.info("{FUH} started.");
	            this.config = {};
	            $.extend(true, this.config, defConfig, config);
	            for (var i = 0; i < this.config.accept.length; i++)
	                this.config.accept[i] = this.config.accept[i].toLowerCase();
	            this.$uploadInput;
	        };
	
	        FileUploadHelper.prototype.render = function (fileInputId) {
	            log.info("{FUH} render ");
	            this.initUploadInput(fileInputId);
	        }
	
	        FileUploadHelper.prototype.reset = function () {
	            log.info("{FUH} reset ");
	            this.$uploadInput.val('');
	        }
	
	        FileUploadHelper.prototype.initUploadInput = function (inputId) {
	            log.info("{FUH} initUploadInput ");
	            this.$uploadInput = $(inputId);
	            var me = this;
	
	            this.$uploadInput.on('change', function (e) {
	                log.info("{FUH} changed ");
	                if (me.config.accept && me.config.accept.length > 0) {
	                    var ext = me.$uploadInput.val().split(".").pop().toLowerCase();
	                    if ($.inArray(ext, me.config.accept) == -1) {
	                        //alert(mlRes.wrongFileType);
	                        alert("wrong file type");
	                        me.reset();
	                        return false;
	                    }
	                }
	                if (me.config.maxFileBytes != 0) {
	                    if (e.target.files.item(0).size > me.config.maxFileBytes) {
	                        //alert(mlRes.maxFileSizeIs.replace("%max%", (me.config.maxFileBytes / 1048576)));
	                        alert('too big');
	                        me.reset();
	                        return false;
	                    }
	                }
	                if (e.target.files != undefined) {
	                    var reader = new FileReader();
	                    Backbone.trigger(widgetName+":"+evtTextFileUploading);
	                    reader.onload = function (e) {
	                        var str = e.target.result;
	                        log.info("{FUH} event triggering ");
	                        log.info(widgetName+":"+evtTextFileUploaded);
	                        Backbone.trigger(widgetName+":"+evtTextFileUploaded,str);
	                    };
	                    reader.readAsText(e.target.files.item(0));
	                }
	                return false;
	            });
	        }
	
	        FileUploadHelper.prototype.enabled = function (isEnabled) {
	            log.info("{FUH} enabled ");
	            if (isEnabled) {
	                this.$uploadInput.removeAttr('disabled');
	            }
	            else {
	                this.$uploadInput.attr('disabled', 'disabled');
	            }
	        }
	
	        FileUploadHelper.prototype.destroy = function () {
	            log.info("{FUH} destroy ");
	            this.$uploadInput.off('change');
	        }
	
	        return FileUploadHelper;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <button data-role=\"save\" title=\""
	    + container.escapeExpression(((helper = (helper = helpers.saveBtn || (depth0 != null ? depth0.saveBtn : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"saveBtn","hash":{},"data":data}) : helper)))
	    + "\"\r\n                type=\"button\" class=\"pull-right btn btn-floating fx-background-color-primary-color\" aria-label=\"Left Align\">\r\n            <span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span>\r\n        </button>\r\n    </div>\r\n    <div id=\"fx-data-management-utility-holder\" ></div>\r\n</div>\r\n\r\n<hr>\r\n<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n       <div data-role=\"data\"></div>\r\n    </div>\r\n</div>";
	},"useData":true});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div data-role=\"menu\" class=\"dropdown\">\r\n    <button title=\""
	    + alias4(((helper = (helper = helpers.uploadCSV || (depth0 != null ? depth0.uploadCSV : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"uploadCSV","hash":{},"data":data}) : helper)))
	    + "\" id=\"btnFileUploader\" class=\"btn btn-floating fx-background-color-primary-color\" type=\"button\" data-toggle=\"dropdown\" aria-expanded=\"true\">\r\n        <span class=\"icojam_cloud_upload\"></span>\r\n    </button>\r\n    <ul class=\"dropdown-menu json-menu csvDropdown\">\r\n        <li class=\"js-menu dropdown-submenu\">\r\n            <label id=\"lblSeparator\" class=\"csvSeparator\" for=\"csvSeparator\">"
	    + alias4(((helper = (helper = helpers.csvSparator || (depth0 != null ? depth0.csvSparator : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"csvSparator","hash":{},"data":data}) : helper)))
	    + "</label>\r\n            <br>\r\n            <select id=\"csvSeparator\" name=\"csvSeparator\" >\r\n                <option id=\"csvSeparatorNull\" value=\"\"></option>\r\n                <option id=\"csvSeparatorComma\" value=\",\">"
	    + alias4(((helper = (helper = helpers.csvSeparatorComma || (depth0 != null ? depth0.csvSeparatorComma : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"csvSeparatorComma","hash":{},"data":data}) : helper)))
	    + "</option>\r\n                <option id=\"csvSeparatorSemi\" value=\";\">"
	    + alias4(((helper = (helper = helpers.csvSeparatorSemi || (depth0 != null ? depth0.csvSeparatorSemi : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"csvSeparatorSemi","hash":{},"data":data}) : helper)))
	    + "</option>\r\n            </select>\r\n        </li>\r\n        <li class=\"js-menu dropdown-submenu\">\r\n            <label id=\"lblUpload\" for=\"dataFUpload\">"
	    + alias4(((helper = (helper = helpers.uploadCSV || (depth0 != null ? depth0.uploadCSV : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"uploadCSV","hash":{},"data":data}) : helper)))
	    + "</label>\r\n            <br>\r\n            <input type=\"file\" name=\"filename\" id=\"dataFUpload\" accept=\".csv\" />\r\n            <br>\r\n        </li>\r\n    </ul>\r\n</div>";
	},"useData":true});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(7),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(8),
	    __webpack_require__(61),
	    __webpack_require__(32)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Backbone, log, Q, labels, template, EVT) {
	
	    "use strict";
	
	    var b = {
	        btnMeta: "#btnMeta",
	        btnDSD: "#btnDSD",
	        btnData: "#btnData",
	    },
	        s = {
	            DManResHeader: "#DManResHeader"
	    };
	
	    var HomeView = Backbone.View.extend({
	
	        render: function (o) {
	
	            $.extend(true, this, {initial: o});
	
	            this._parseInput();
	
	            var valid = this._validateInput();
	
	            if (valid === true) {
	
	                log.info("Rendering View - Home", this);
	
	                this._attach();
	
	                this._bindEventListeners();
	
	                return this;
	            } else {
	                log.error("Impossible to render Home");
	                log.error(valid)
	            }
	        },
	
	        _validateInput: function () {
	
	            var valid = true,
	                errors = [];
	            
	            return errors.length > 0 ? errors : valid;
	        },
	
	        _parseInput: function () {
	
	            this.cache = this.initial.cache;
	            this.environment = this.initial.environment;
	            this.disabledSections = this.initial.disabledSections;
	            this.lang = this.initial.lang.toLowerCase();
	
	            log.info('Disabled Sections', this.disabledSections);
	        },
	
	        _attach: function () {
	            var self = this;
	            this.$el.html(template({
	                btnMeta: labels[this.lang]['btnMetadata'],
	                btnDSD: labels[this.lang]['btnDSD'],
	                btnData: labels[this.lang]['btnData'],
	                DManResHeader: labels[this.lang]['DManResHeader']
	            }));
	
	            $.each(this.disabledSections, function(index,object){
	                // hide disabled buttons
	                self.$el.find(b[object]).parent().hide();
	            });
	        },
	
	        _bindEventListeners: function () {
	
	            if (this.$el.find(b.btnMeta).is(":visible"))
	                this.$el.find(b.btnMeta).on("click", function () {
	                    Backbone.trigger(EVT.SHOW_METADATA);
	                });
	
	            if (this.$el.find(b.btnDSD).is(":visible"))
	                this.$el.find(b.btnDSD).on("click", function () {
	                    Backbone.trigger(EVT.SHOW_DSD);
	                });
	
	            if (this.$el.find(b.btnData).is(":visible"))
	                this.$el.find(b.btnData).on("click", function () {
	                    Backbone.trigger(EVT.SHOW_DATA);
	                });
	
	        },
	
	        _unbindEventListeners: function () {
	            this.$el.find(b.btnMeta).off();
	            this.$el.find(b.btnDSD).off();
	            this.$el.find(b.btnData).off();
	        },
	
	        accessControl: function (Resource) {
	
	            return new Q.Promise(function (fulfilled, rejected) {
	                if (!$.isEmptyObject(Resource)) {
	                    fulfilled();
	                } else {
	                    rejected();
	                }
	            });
	        },
	
	        remove: function () {
	            this._unbindEventListeners();
	            Backbone.View.prototype.remove.apply(this, arguments);
	        }
	    });
	
	    return HomeView;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"row\">\r\n    <div class=\"col-md-6 col-md-offset-3\">\r\n        <div class=\"text-center\">\r\n            <h3 id=\"DManResHeader\">"
	    + alias4(((helper = (helper = helpers.DManResHeader || (depth0 != null ? depth0.DManResHeader : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"DManResHeader","hash":{},"data":data}) : helper)))
	    + "</h3>\r\n\r\n            <div class=\"btn-group btn-group-justified\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button id=\"btnMeta\" data-section=\"metadata\" title=\""
	    + alias4(((helper = (helper = helpers.btnMeta || (depth0 != null ? depth0.btnMeta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnMeta","hash":{},"data":data}) : helper)))
	    + "\" class=\"btn btn-default fx-button-primary-color\" > "
	    + alias4(((helper = (helper = helpers.btnMeta || (depth0 != null ? depth0.btnMeta : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnMeta","hash":{},"data":data}) : helper)))
	    + " </button>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button id=\"btnDSD\" data-section=\"dsd\" title=\""
	    + alias4(((helper = (helper = helpers.btnDSD || (depth0 != null ? depth0.btnDSD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnDSD","hash":{},"data":data}) : helper)))
	    + "\" class=\"btn btn-default fx-button-primary-color\" > "
	    + alias4(((helper = (helper = helpers.btnDSD || (depth0 != null ? depth0.btnDSD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnDSD","hash":{},"data":data}) : helper)))
	    + " </button>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button id=\"btnData\" data-section=\"data\" title=\""
	    + alias4(((helper = (helper = helpers.btnData || (depth0 != null ? depth0.btnData : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnData","hash":{},"data":data}) : helper)))
	    + "\" class=\"btn btn-default fx-button-primary-color\" > "
	    + alias4(((helper = (helper = helpers.btnData || (depth0 != null ? depth0.btnData : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnData","hash":{},"data":data}) : helper)))
	    + " </button>\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n";
	},"useData":true});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(33),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(42),
	    __webpack_require__(7),
	    __webpack_require__(32),
	    __webpack_require__(37)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, log, Q, Bridge, Backbone, EVT, C) {
	
	    "use strict";
	
	    function ResourceManager() {
	        log.info("FENIX DM - Resource Manager");
	
	        this.resource = {};
	
	        log.info("FENIX DM - Resource Manager completed.");
	    }
	
	    ResourceManager.prototype.init = function (opts) {
	        log.info("Resource manager config:");
	        log.info(opts);
	
	
	        if (opts.extra) this.extra = opts.extra;
	
	        this.bridge = new Bridge({
	            environment: opts.environment,
	            cache: opts.cache,
	            extra: opts.extra,
	            serviceProvider: opts.serviceProvider
	        });
	
	    };
	
	    ResourceManager.prototype.getEnvironment = function () {
	        log.info("FENIX DM - Current Environment: " + this.environment);
	        log.info("FENIX DM - Current Bridge Environment: " + this.bridge.environment);
	        log.info("FENIX DM - Current DataManagment Environment: " + this.dmEnvironment);
	        return this.environment;
	    };
	
	
	    // Validation
	
	    ResourceManager.prototype.isResourceValid = function (Res) {
	        return (
	            (this.isValidMetadata(Res.metadata)) &&
	            (this.isDSDValid(Res.metadata.dsd)) &&
	            (this.isDataValid(Res.data))
	        );
	    };
	
	    ResourceManager.prototype.isDSDValid = function (DSDRes) {
	
	        if (!DSDRes) {
	            Backbone.trigger("error:showerrormsg", "DSD to update cannot be null");
	            throw new Error("DSD to update cannot be null");
	        }
	        if (!DSDRes.datasources) {
	            Backbone.trigger("error:showerrormsg", "Datasources cannot be null");
	            throw new Error("Datasources cannot be null");
	        }
	        else if (DSDRes.datasources.length == 0) {
	            Backbone.trigger("error:showerrormsg", "Datasources cannot be null");
	            throw new Error("Datasources cannot be null");
	        }
	        if (!DSDRes.contextSystem) {
	            Backbone.trigger("error:showerrormsg", "ContextSystem cannot be null");
	            throw new Error("ContextSystem cannot be null");
	        }
	
	        return true
	    };
	
	    ResourceManager.prototype.MetadataExist = function () {
	        if ( (this.resource.metadata !== undefined) && (this.resource.metadata.uid !== undefined) ) return true;
	        return 0;
	    };
	
	    ResourceManager.prototype.DSDExist = function () {
	        if (this.resource.metadata.dsd.columns !== undefined ) return this.resource.metadata.dsd.columns.length;
	        return 0;
	    };
	
	    ResourceManager.prototype.dataExist = function () {
	        if (this.resource.data !== undefined) return this.resource.data.length;
	        return 0;
	    };
	
	    ResourceManager.prototype.isDataValid = function (DataRes) {
	        //TODO: There's no logic here with the current form of the Data Editor
	        return true
	    };
	
	    ResourceManager.prototype.isValidMetadata = function (MetaRes) {
	        //TODO: There's no logic here with the current form of the MetaData Editor
	        return true
	    };
	
	    // Controls
	
	    ResourceManager.prototype.isMetadataEmpty = function () {
	        if (this.resource.metadata)
	            return ((this.resource.metadata.length > 0 ));
	            return true;
	    };
	
	    ResourceManager.prototype.isDSDEmpty = function () {
	        return ((this.resource.metadata.dsd.columns === undefined ));
	    };
	
	    ResourceManager.prototype.isDSDEditable = function () {
	        if (this.resource.data !== undefined) return false;
	        return true;
	    };
	
	    // Resource
	
	    ResourceManager.prototype.createResource = function (opts) {
	
	        var body = $.extend(true, {}, this.resource.metadata);
	
	        if (!opts.contextSystem) {
	            log.error("Impossible to find context system");
	            alert("Impossible to find context system");
	            return;
	        }
	
	        if (!opts.resourceRepresentationType) {
	            log.error("Impossible to find resourceRepresentationType");
	            alert("Impossible to find resourceRepresentationType");
	            return;
	        }
	
	        if (Array.isArray(opts.datasources) && opts.datasources.length === 0) {
	            log.error("Data Sources can not be null");
	            alert("Data Sources can not be null");
	            return;
	        }
	
	
	        if(this.isMetadataEmpty()) {
	            this.resource.metadata = {};
	            this.resource.metadata.meContent = {};
	            this.resource.metadata.dsd = {};
	            this.resource.metadata.dsd.contextSystem = opts.contextSystem;
	            this.resource.metadata.dsd.datasources = opts.datasources;
	            this.resource.metadata.meContent.resourceRepresentationType = opts.resourceRepresentationType;
	
	            Backbone.trigger(EVT.RESOURCE_CREATED);
	            return;
	        }
	
	        if (this.extra != undefined) body = $.extend(true, {}, { metadata : body } , this.extra);
	
	
	        this.bridge.saveMetadata({
	            body: body,
	            dsdRid: this.getNestedProperty("metadata.dsd.rid", this.resource)
	        }).then(_.bind(function (resource) {
	                log.info("Resource crated", resource);
	                this.resource.metadata.uid = resource.uid;
	                this.resource.metadata.dsd.rid = resource.dsd.rid;
	                //$.extend(true, this.resource.metadata, resource);
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	            }, this), function (xhr, textstatus) {
	                log.error("Error metadata update");
	                log.error(xhr);
	                log.error(textstatus);
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	            }
	        );
	
	
	    };
	
	    ResourceManager.prototype.deleteMetadata = function () {
	        this.bridge.deleteMetadata({
	            uid: this.resource.metadata.uid,
	            version: this.resource.metadata.version
	        }).then(
	            _.bind(function () {
	                this.resource = {};
	                Backbone.trigger(EVT.RESOURCE_DELETED);
	            }, this),
	            _.bind(function () {
	                Backbone.trigger("error:showerrorsrv", null);
	            }, this)
	        );
	
	    };
	
	    ResourceManager.prototype.deleteResource = function () {
	
	        this.bridge.deleteResource({
	            uid: this.resource.metadata.uid,
	            version: this.resource.metadata.version
	        }).then(
	            _.bind(function () {
	                this.resource = {};
	                Backbone.trigger(EVT.RESOURCE_DELETED);
	            }, this),
	            _.bind(function () {
	                Backbone.trigger("error:showerrorsrv", null);
	            }, this)
	        );
	
	    };
	
	    ResourceManager.prototype.unloadResource = function () {
	        log.info("RM - unloadResource");
	        this.resource = {};
	        Backbone.trigger(EVT.RESOURCE_UNLOADED);
	    };
	
	    ResourceManager.prototype.getCodelist = function (codelistUID) {
	        log.info('getCodelist called ', codelistUID);
	        var requ = {
	            uid: codelistUID
	        };
	        if (codelistUID.indexOf("|") != -1) {
	            requ['version'] = codelistUID.substr(codelistUID.indexOf("|") + 1, codelistUID.length);
	            requ['uid'] = codelistUID.substr(0, codelistUID.indexOf("|"));
	        }
	        log.info('>bridge.getResource', requ);
	        return this.bridge.getResource(requ).then(
	            function (resource) {
	                log.info('<bridge.getResource', resource);
	                return resource;
	            }
	        );
	    };
	
	    ResourceManager.prototype.loadResource = function (resource) {
	        log.info("Load resource");
	        log.info(resource);
	
	        this.bridge.getResource({
	            uid: resource.model.uid,
	            version: resource.model.version,
	            params: {dsd: true, full: true, export: true}
	        }).then(
	            _.bind(this._onLoadResourceSuccess, this, resource),
	            _.bind(this._onLoadResourceError, this)
	        );
	    };
	
	    ResourceManager.prototype._onLoadResourceSuccess = function (catalogModel, resource) {
	
	        log.info("Load resource success", resource);
	
	        if (!resource) {
	            log.error("Resource is empty");
	            Backbone.trigger("error:showerrormsg", "Resource is empty");
	        }
	
	        this.assign(resource, "metadata.uid", this.getNestedProperty("uid", catalogModel.model));
	        this.assign(resource, "metadata.version", this.getNestedProperty("version", catalogModel.model));
	        this.assign(resource, "metadata.dsd.rid", this.getNestedProperty("dsd.rid", catalogModel.model));
	        var updDate = this.getNestedProperty("meMaintenance.seUpdate.updateDate", catalogModel.model);
	        this.assign(resource, "metadata.meMaintenance.seUpdate.updateDate", updDate);
	        this.assign(resource, "metadata.creationDate", this.getNestedProperty("creationDate", catalogModel.model));
	
	        this.setResource(resource);
	
	        Backbone.trigger(EVT.RESOURCE_LOADED);
	    };
	
	    ResourceManager.prototype._onLoadResourceError = function (e) {
	        log.error("Load resource error", e);
	        log.error(e);
	        Backbone.trigger("error:showerrormsg", "Connection error");
	    };
	
	    // METADATA
	
	    ResourceManager.prototype.getMetadata = function () {
	        log.info("Get Metadata", this.resource.metadata);
	        return (this.isValidMetadata(this.resource.metadata)) ? this.resource.metadata : {};
	    };
	
	    ResourceManager.prototype._onGetMetadataSuccess = function (resource) {
	        log.info("_onGetMetadataSuccess");
	        log.info(resource);
	    };
	
	    ResourceManager.prototype._onGetMetadataError = function (e) {
	        log.error("_onGetMetadataError");
	        log.error(e);
	        Backbone.trigger("error:showerrormsg", "Connection error");
	        return false;
	    };
	
	    ResourceManager.prototype.saveMetadata = function () {
	        log.info("saveMetadata Called.");
	
	        this.bridge.updateMetadata({
	            body: $.extend(true, {}, this.resource.metadata),
	            dsdRid: this.getNestedProperty("metadata.dsd.rid", this.resource)
	        }).then(
	            _.bind(function (data) {
	                log.info("Success metadata update");
	                log.info(data);
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	
	            }, this),
	            _.bind(function (xhr, textstatus) {
	                log.error("Error metadata update");
	                log.error(xhr);
	                log.error(textstatus);
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	            }, this));
	    };
	
	    ResourceManager.prototype.setResource = function (resource) {
	        this.resource = resource;
	    };
	
	    ResourceManager.prototype.updateMetadata = function (metadata) {
	
	        var metadataEntities = [
	                "meIdentification",
	                "meDocuments",
	                "meInstitutionalMandate",
	                "meAccessibility",
	                "meContent",
	                "meDataQuality",
	                "meMaintenance",
	                "meReferenceSystem",
	                "meResourceStructure",
	                "meSpatialRepresentation",
	                "meStatisticalProcessing"
	            ],
	            fields = [
	                "language",
	                "languageDetails",
	                "title",
	                "creationDate",
	                "characterSet",
	                "metadataStandardName",
	                "metadataStandardVersion",
	                "metadataLanguage",
	                "contacts",
	                "noDataValue",
	                "additions"
	            ],
	            resourceRepresentationType = this.getNestedProperty("metadata.meContent.resourceRepresentationType", this.resource) || C.config.resourceRepresentationType;
	            // metadata.meMaintenance.seMetadataMaintenance.metadataLastUpdate
	
	        _.each(fields, _.bind(function (f) {
	            this.assign(this.resource, "metadata." + f, metadata[f]);
	        }, this));
	
	        _.each(metadataEntities, _.bind(function (m) {
	            if (metadata[m]) {
	                this.assign(this.resource, "metadata." + m, metadata[m]);
	            }
	
	        }, this));
	
	
	        //var hammer = + new Date();
	        //console.log('It\'s ' + hammer + ' time!' );
	        //force resourceRepresentationType
	        this.assign(this.resource, "metadata.meContent.resourceRepresentationType", resourceRepresentationType);
	        //this.assign(this.resource, "metadata.meMaintenance.seMetadataMaintenance.metadataLastUpdate", hammer);
	
	    };
	
	    // DSD
	
	    ResourceManager.prototype.getDSD = function () {
	
	        return this.resource && this.resource.metadata ? $.extend(true, {}, this.resource.metadata.dsd) : undefined;
	    };
	
	    ResourceManager.prototype.updateDsd = function (dsd) {
	
	
	        var dsdRid = this.getNestedProperty("metadata.dsd.rid", this.resource);
	
	        dsd.rid = dsdRid;
	
	        if (!dsd.rid) {
	            log.warn("DSD rid not found");
	            log.warn(this.resource);
	        }
	
	        this.assign(this.resource, "metadata.dsd", dsd);
	
	    };
	
	    ResourceManager.prototype.saveDsd = function () {
	
	        this.bridge.updateDSD({
	            body: this.resource.metadata.dsd
	        }).then(
	            _.bind(function (data) {
	                log.info("Success dsd update");
	                log.info(data);
	
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	
	            }, this),
	            _.bind(function (xhr, textstatus) {
	
	                log.error("Error dsd update");
	                log.error(xhr);
	                log.error(textstatus);
	
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	
	            }, this));
	    };
	
	    // Data
	
	    ResourceManager.prototype.getData = function () {
	        log.info("getData called.", this.resource.data);
	        return this.resource.data;
	    };
	
	    ResourceManager.prototype.setDataEmpty = function () {
	        log.info("setDataEmpty called.");
	        this.resource.data = {};
	    };
	
	    ResourceManager.prototype.setData = function (resource) {
	        log.info("setData called.", resource);
	        if (this.isDataValid(resource)) {
	            this.resource.data = resource;
	            // Data needs the whole package.
	            this.updateData(this.resource.data);
	        }
	    };
	
	    ResourceManager.prototype.updateData = function (resource) {
	        log.info("updateData Called.", resource);
	
	        this.bridge.updateData({
	            body: {
	                "metadata": {
	                    uid: this.resource.metadata.uid
	                },
	                "data": resource
	            }
	        }).then(
	            _.bind(function (data) {
	
	                log.info("Success data update");
	                log.info(data);
	
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	
	            }, this),
	            _.bind(function (xhr, textstatus) {
	                log.error("Error data update");
	                log.error(xhr);
	                log.error(textstatus);
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	            }, this));
	
	    };
	
	    // Utils
	
	    ResourceManager.prototype.getCurrentResourceCodelists = function () {
	        log.info("getCurrentResourceCodelists called.")
	        if (this.resource.metadata === undefined) return null;
	        if (this.resource.metadata.dsd === undefined) return null;
	        if (this.resource.metadata.dsd.columns === undefined) return null;
	        var codelists = [];
	        var columns = this.resource.metadata.dsd.columns;
	        $.each(columns, function (index, object) {
	            var output = "";
	            if (object.dataType == "code") {
	                output = object.domain.codes[0].idCodeList;
	                if (object.domain.codes[0].version) output = output + "|" + object.domain.codes[0].version;
	                codelists.push(output);
	            }
	        });
	
	        return _.unique(codelists);
	    };
	
	    ResourceManager.prototype.generateDSDStructure = function () {
	        log.info("generateDSDStructure called.")
	        var self = this;
	        var codelists = self.getCurrentResourceCodelists();
	        var ps = [];
	
	        $.each(codelists, function (index, object) {
	            ps.push(self.getCodelist(object));
	        });
	
	        return Q.all(ps).then(function (result) {
	            var structure = {};
	            $.each(result, function (index, object) {
	                if (object.metadata.version) {
	                    structure[object.metadata.uid + "|" + object.metadata.version] = object;
	                } else {
	                    structure[object.metadata.uid] = object;
	                }
	            });
	            return structure;
	        });
	    };
	
	    //Utils
	
	    ResourceManager.prototype.assign = function (obj, prop, value) {
	        if (typeof prop === "string")
	            prop = prop.split(".");
	
	        if (prop.length > 1) {
	            var e = prop.shift();
	            this.assign(obj[e] =
	                    Object.prototype.toString.call(obj[e]) === "[object Object]"
	                        ? obj[e]
	                        : {},
	                prop,
	                value);
	        } else {
	            obj[prop[0]] = value;
	        }
	    };
	
	    ResourceManager.prototype.getNestedProperty = function (path, obj) {
	
	        var obj = $.extend(true, {}, obj),
	            arr = path.split(".");
	
	        while (arr.length && (obj = obj[arr.shift()]));
	
	        return obj;
	
	    };
	
	    return new ResourceManager();
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(6),
	    __webpack_require__(33),
	    __webpack_require__(3),
	    __webpack_require__(46),
	    __webpack_require__(42),
	    __webpack_require__(7),
	    __webpack_require__(32),
	    __webpack_require__(37)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, log, Q, Bridge, Backbone, EVT, C) {
	
	    var originalCreationDate;
	
	    "use strict";
	
	    function ResourceManager() {
	        log.info("FENIX DM - Resource Manager for GIFT");
	
	        this.resource = {};
	
	        log.info("FENIX DM - Resource Manager completed.");
	    }
	
	    ResourceManager.prototype.init = function (opts) {
	        log.info("Resource manager config:");
	        log.info(opts);
	
	        if (opts.extra) this.extra = opts.extra;
	
	        this.bridge = new Bridge({
	            environment: opts.environment,
	            cache: opts.cache,
	            extra: opts.extra,
	            serviceProvider : opts.serviceProvider
	        });
	    };
	
	    ResourceManager.prototype.getEnvironment = function () {
	        log.info("FENIX DM - Current Environment: " + this.environment);
	        log.info("FENIX DM - Current Bridge Environment: " + this.bridge.environment);
	        log.info("FENIX DM - Current DataManagment Environment: " + this.dmEnvironment);
	        return this.environment;
	    };
	
	
	    // Validation
	
	    ResourceManager.prototype.isResourceValid = function (Res) {
	        return this.isValidMetadata(Res.metadata);
	    };
	
	
	    ResourceManager.prototype.MetadataExist = function () {
	        if (this.resource.metadata !== undefined) return true;
	        return 0;
	    };
	
	    ResourceManager.prototype.isValidMetadata = function (MetaRes) {
	        //TODO: There's no logic here with the current form of the MetaData Editor
	        return true
	    };
	
	    // Controls
	
	    ResourceManager.prototype.isMetadataEmpty = function () {
	        if (this.resource.metadata)
	            return ((this.resource.metadata.length > 0 ));
	            return true;
	    };
	
	    // Resource
	
	    ResourceManager.prototype.createResource = function (opts) {
	
	        var body = $.extend(true, {}, this.resource.metadata);
	
	        if (!opts.contextSystem) {
	            log.error("Impossible to find context system");
	            alert("Impossible to find context system");
	            return;
	        }
	
	        if (!opts.resourceRepresentationType) {
	            log.error("Impossible to find resourceRepresentationType");
	            alert("Impossible to find resourceRepresentationType");
	            return;
	        }
	
	        if (Array.isArray(opts.datasources) && opts.datasources.length === 0) {
	            log.error("Data Sources can not be null");
	            alert("Data Sources can not be null");
	            return;
	        }
	
	
	        if(this.isMetadataEmpty()) {
	            this.resource.metadata = {};
	
	            Backbone.trigger(EVT.RESOURCE_CREATED);
	            return;
	        }
	
	        if (this.extra != undefined) body = $.extend(true, {}, { metadata : body } , this.extra);
	
	
	        this.bridge.saveMetadata({
	            body: body
	        }).then(_.bind(function (resource) {
	                log.info("Resource crated", resource);
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	            }, this), function (xhr, textstatus) {
	                log.error("Error metadata update");
	                log.error(xhr);
	                log.error(textstatus);
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	            }
	        );
	
	
	    };
	
	    ResourceManager.prototype.deleteMetadata = function () {
	        this.bridge.deleteMetadata({
	            uid: this.resource.metadata.administration.uid
	        }).then(
	            _.bind(function () {
	                this.resource = {};
	                Backbone.trigger(EVT.RESOURCE_DELETED);
	            }, this),
	            _.bind(function () {
	                Backbone.trigger("error:showerrorsrv", null);
	            }, this)
	        );
	
	    };
	
	    ResourceManager.prototype.deleteResource = function () {
	
	        this.bridge.deleteResource({
	            uid: this.resource.metadata.administration.uid
	        }).then(
	            _.bind(function () {
	                this.resource = {};
	                Backbone.trigger(EVT.RESOURCE_DELETED);
	            }, this),
	            _.bind(function () {
	                Backbone.trigger("error:showerrorsrv", null);
	            }, this)
	        );
	
	    };
	
	    ResourceManager.prototype.unloadResource = function () {
	        log.info("RM - unloadResource");
	        this.resource = {};
	        Backbone.trigger(EVT.RESOURCE_UNLOADED);
	    };
	
	    ResourceManager.prototype.getCodelist = function (codelistUID) {
	        log.info('getCodelist called ', codelistUID);
	        var requ = {
	            uid: codelistUID
	        };
	        if (codelistUID.indexOf("|") != -1) {
	            requ['version'] = codelistUID.substr(codelistUID.indexOf("|") + 1, codelistUID.length);
	            requ['uid'] = codelistUID.substr(0, codelistUID.indexOf("|"));
	        }
	        log.info('>bridge.getResource', requ);
	        return this.bridge.getResource(requ).then(
	            function (resource) {
	                log.info('<bridge.getResource', resource);
	                return resource;
	            }
	        );
	    };
	
	    ResourceManager.prototype.loadResource = function (resource) {
	        log.info("Load resource");
	        log.info(resource);
	
	        this.bridge.getMetadata({
	            uid: resource.model.uid,
	            params: {dsd: true, full: true, export: true}
	        }).then(
	            _.bind(this._onLoadResourceSuccess, this, resource),
	            _.bind(this._onLoadResourceError, this)
	        );
	    };
	
	    ResourceManager.prototype._onLoadResourceSuccess = function (catalogModel, resource) {
	
	        log.info("Load resource success", resource);
	
	        if (!resource) {
	            log.error("Resource is empty");
	            Backbone.trigger("error:showerrormsg", "Resource is empty");
	        }
	
	        //To visualize the title on the page. Current metadata structure save the title in the survey name field
	        this.assign(resource, "title", resource.generalInformation.surveyName);
	        this.assign(resource, "uid", resource.administration.uid);
	        this.assign(resource, "creationDate", resource.administration.creationDate);
	        this.assign(resource, "metadataLastUpdate", resource.administration.metadataLastUpdate);
	        this.assign(resource, "datasetAvailability", resource.administration.datasetAvailability);
	
	        originalCreationDate = resource.administration.creationDate;
	
	        if(resource.sampledPopulationInfo.groupsSurveyed !== undefined){
	
	            var array = [];
	            array = resource.sampledPopulationInfo.groupsSurveyed.map(function (o) {
	                var value;
	                if(o["PopulationGroupsList"]!== undefined)
	                    value = o["PopulationGroupsList"]["EN"];
	                return value;
	            });
	            resource.sampledPopulationInfo.groupsSurveyed = array;
	        }
	
	        if(resource.sampledPopulationInfo.purposelyGroups !== undefined){
	
	            var array = [];
	            array = resource.sampledPopulationInfo.purposelyGroups.map(function (o) {
	                var value;
	                if(o["PurposedlyGroupsList"]!== undefined)
	                    value = o["PurposedlyGroupsList"]["EN"];
	                return value;
	            });
	            resource.sampledPopulationInfo.purposelyGroups = array;
	        }
	
	        if(resource.foodCompositionInfo.macronutrientDetails !== undefined){
	
	            var array = [];
	            array = resource.foodCompositionInfo.macronutrientDetails.map(function (o) {
	                var value;
	                if(o["MacroDietaryComponentsDetailsList"]!== undefined)
	                    value = o["MacroDietaryComponentsDetailsList"]["EN"];
	                return value;
	            });
	            resource.foodCompositionInfo.macronutrientDetails = array;
	        }
	
	        if(resource.foodCompositionInfo.micronutrientDetails !== undefined){
	
	            var array = [];
	            array = resource.foodCompositionInfo.micronutrientDetails.map(function (o) {
	                var value;
	                if(o["MicroDietaryComponentsDetailsList"]!== undefined)
	                    value = o["MicroDietaryComponentsDetailsList"]["EN"];
	                return value;
	            });
	            resource.foodCompositionInfo.micronutrientDetails = array;
	        }
	
	        log.info("Load resource success after", resource);
	
	        this.setResource({ metadata: resource });
	
	        Backbone.trigger(EVT.RESOURCE_LOADED);
	    };
	
	    ResourceManager.prototype._onLoadResourceError = function (e) {
	        log.error("Load resource error", e);
	        log.error(e);
	        Backbone.trigger("error:showerrormsg", "Connection error");
	    };
	
	    // METADATA
	
	    ResourceManager.prototype.getMetadata = function () {
	        log.info("Get Metadata", this.resource);
	        return this.resource;
	    };
	
	    ResourceManager.prototype._onGetMetadataSuccess = function (resource) {
	        log.info("_onGetMetadataSuccess");
	        log.info(resource);
	    };
	
	    ResourceManager.prototype._onGetMetadataError = function (e) {
	        log.error("_onGetMetadataError");
	        log.error(e);
	        Backbone.trigger("error:showerrormsg", "Connection error");
	        return false;
	    };
	
	    ResourceManager.prototype.saveMetadata = function () {
	        log.info("saveMetadata Called.");
	
	        this.bridge.updateMetadata({
	            body: $.extend(true, {}, this.resource)
	        }).then(
	            _.bind(function (data) {
	                log.info("Success metadata update");
	                log.info(data);
	                Backbone.trigger(EVT.RESOURCE_UPDATED);
	
	            }, this),
	            _.bind(function (xhr, textstatus) {
	                log.error("Error metadata update");
	                log.error(xhr);
	                log.error(textstatus);
	                Backbone.trigger("error:showerrorsrv", null, xhr);
	            }, this));
	    };
	
	    ResourceManager.prototype.setResource = function (resource) {
	        this.resource = resource;
	    };
	
	    ResourceManager.prototype.updateMetadata = function (metadata) {
	
	        console.log(' updating metadata ');
	
	        var metadataEntities = [
	                "generalInformation",
	                "surveyInformation",
	                "samplingInformation",
	                "sampledPopulationInfo",
	                "dataAnalysisInfo",
	                "foodConsumptionInfo",
	                "foodCompositionInfo",
	                "additionalInfo"
	            ],
	            fields = [
	                "uid",
	                "creationDate",
	                "datasetAvailability",
	                "metadataLastUpdate"
	            ];
	            // metadata.meMaintenance.seMetadataMaintenance.metadataLastUpdate
	
	        _.each(fields, _.bind(function (f) {
	
	            this.assign(this.resource, "metadata.administration." + f, metadata[f]);
	            delete this.resource.metadata[f];
	        }, this));
	
	        _.each(metadataEntities, _.bind(function (m) {
	            if (metadata[m]) {
	
	                this.assign(this.resource, "metadata." + m, metadata[m]);
	            }
	        }, this));
	
	        var d = new Date().getTime();
	
	        this.assign(this.resource, "metadata.administration.metadataLastUpdate", d);
	        this.assign(this.resource, "metadata.administration.creationDate", originalCreationDate);
	
	
	        //this.assign(this.resource.metadata, "metadata.meContent.resourceRepresentationType", resourceRepresentationType);
	
	        console.log('correct', JSON.stringify(this.resource));
	
	    };
	
	    //Utils
	
	    ResourceManager.prototype.assign = function (obj, prop, value) {
	        if (typeof prop === "string")
	            prop = prop.split(".");
	
	        if (prop.length > 1) {
	            var e = prop.shift();
	            this.assign(obj[e] =
	                    Object.prototype.toString.call(obj[e]) === "[object Object]"
	                        ? obj[e]
	                        : {},
	                prop,
	                value);
	        } else {
	            obj[prop[0]] = value;
	        }
	    };
	
	    ResourceManager.prototype.getNestedProperty = function (path, obj) {
	
	        var obj = $.extend(true, {}, obj),
	            arr = path.split(".");
	
	        while (arr.length && (obj = obj[arr.shift()]));
	
	        return obj;
	
	    };
	
	    return new ResourceManager();
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(12);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"fx-data-management\" class=\"data-mng-container container-fluid\">\r\n\r\n    <div id=\"fx-data-management-menu\" class=\"fx-data-management-menu\"></div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <h3>\r\n                <span id=\"fx-data-managment-header-title\"></span>\r\n                <span id=\"fx-data-managment-resource-title\"></span>\r\n            </h3>\r\n\r\n        </div>\r\n    </div>\r\n\r\n    <div id=\"fx-data-management-content-holder\"></div>\r\n\r\n</div>";
	},"useData":true});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	
	    return {
	
	        MLEditor: {
	            langs: ["EN", "FR"]
	        },
	        DSD_EDITOR_CODELISTS: [
	            {
	                "value": "HS|2012",
	                "text": {
	                    "EN": "HS",
	                    "FR": "HS FR"
	                },
	                "subject": "item"
	            },
	            {
	                "value": "CPC|2.1",
	                "text": {
	                    "EN": "CPC",
	                    "FR": "CPC FR"
	                },
	                "subject": "item"
	            },
	            {
	                "value": "CountrySTAT_Indicators",
	                "text": {
	                    "EN": "CountrySTAT_Indicators",
	                    "FR": "CountrySTAT_Indicators FR"
	                },
	                "subject": "indicator"
	            },
	            {
	                "value": "CountrySTAT_UM",
	                "text": {
	                    "EN": "CountrySTAT_UM",
	                    "FR": "CountrySTAT_UM FR"
	                },
	                "subject": "um"
	            },
	            {
	                "value": "UNECA_ISO3",
	                "text": {
	                    "EN": "UNECA_ISO3",
	                    "FR": "UNECA_ISO3 FR"
	                },
	                "subject": "geo"
	            },
	            {
	                "value": "UNECA_ClassificationOfActivities|2.0",
	                "text": {
	                    "EN": "UNECA_ClassificationOfActivities 2.0",
	                    "FR": "UNECA_ClassificationOfActivities 2.0 FR"
	                },
	                "subject": "item"
	            },
	            {
	                "value": "Flag",
	                "text": {
	                    "EN": "Flag",
	                    "FR": "Flag FR"
	                },
	                "subject": "flag"
	            },
	            {
	                "value": "UNECA_Gender",
	                "text": {
	                    "EN": "UNECA_Gender",
	                    "FR": "UNECA_Gender FR"
	                },
	                "subject": "gender"
	            },
	            {
	                "value": "UNECA_Energy",
	                "text": {
	                    "EN": "UNECA_Energy",
	                    "FR": "UNECA_Energy"
	                },
	                "subject": "item"
	            },
	            {
	                "value": "UNECA_UnitMeasure",
	                "text": {
	                    "EN": "UNECA_UnitMeasure UM",
	                    "FR": "UNECA_UnitMeasure UM FR"
	                },
	                "subject": "um"
	            }
	
	        ]
	
	    };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	
	    'use strict';
	
	    return {
	
	        fabri : false
	    }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    return {
	
	    };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// fenix-ui-data-management.min.js